import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  InputAdornment,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Badge,
  Pagination,
  PaginationItem,
  Divider,
  SelectChangeEvent,
} from "@mui/material";
import {
  Add,
  Delete,
  DeleteOutline,
  Download,
  FilterList,
  MoreVert,
  Search,
  FirstPage,
  LastPage,
  Remove,
  CloudUpload,
  Close,
  PhotoCamera,
} from "@mui/icons-material";
import MapPinLocation from "../../../shared/components/MapPinLocation.tsx";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import { styled } from "@mui/system";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FormHelperText from "@mui/material/FormHelperText";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  getLelang,
  lelangSearchParams,
  createLelang,
  uploadItemPhoto,
  deleteLelang,
  updateLelang,
  fetchLelang,
  getLelangById,
  fetchLelangPhotoBlob,
  createLelangLocation,
  fetchVendors,
  uploadProposal,
  getProposalFile,
  deleteProposalFile,
} from "../services/lelangProcessService.tsx";
import { getAllProjects, getProjectById } from "../services/projectListingService.tsx";
import { RABSearchParams, getRab, getRabDetail } from "../services/rabService.tsx";
import { RAPSearchParams, getRap } from "../services/rapService.tsx";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import AddIcon from "@mui/icons-material/Add";
import { GridOn } from "@mui/icons-material";

import {
  LocationSearchParams,
  getLocations,
  createLocation,
  editLocation,
  deleteLocation,
} from "../../data_management/services/locationService.tsx";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";

interface Lelang {
  projectName: string;
  rabName: string;
  bidAmmount: string;
  lelangDate: string;
  clientName: string;
  projectType: string;
  constructionPhase: string;
  projectProcess: string;
  vendorNames: string;
  status: string;
}

interface Vendor {
  vendorId: string;
  vendorName: string; // Perbaiki typo dari vendorNameame
  vendorAddress: string;
  vendorContactNumber: string;
  vendorEmail: string;
  vendorType: string;
  vendorTaxId: string;
  vendorBankDetails: string;
  vendorStatus: string;
  photoVendor?: string; // Tambahkan field untuk foto
}

interface RabOption {
  id: string;
  rabName: string;
  totalPrice: string;
  project: {
    id: string;
    projectName: string;
    projectReferenceId: string;
    startDate: string;
    endDate: string;
    // Tambahkan field lain yang diperlukan
  };
}

interface ProjectOption {
  salesProjectId: string;
  vendorProjectValue: any;
  id: string;
  projectName: string;
  projectReferenceId: string;
  projectId?: string;
  source: string;
  projectType: string;
  constructionPhase: string;
  projectAddress: string;
  projectLocation?: string;
  clientName?: string;
  actualProjectName?: string; // Add field for actual project name
  rabName?: string;
  totalPrice?: string;
  rabValue?: string;
  vendorNames: any;
  startDate?: string;
  endDate?: string;
  projectProcess?: string;
  lelangStatus?: string;
  latitude: string;
  longitude: string;
  region: string;
  province: string;
  city: string;
  district: string;
}

interface RABApiResponse {
  total: number;
  data: {
    id: string;
    rabName: string;
    totalPrice: string;
    project: {
      id: string;
      projectName: string;
      projectReferenceId: string;
      startDate: string;
      endDate: string;
    };
  }[];
  pagination: {
    limit: number;
    offset: number;
    currentPage: number;
    totalPages: number;
  };
}

interface AdvancedSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearchResults: (results: Lelang[]) => void;
}

// === File constraints (Docs) ===
const MAX_UPLOAD_SIZE = 2 * 1024 * 1024; // 2MB
const ALLOWED_EXTS = ["csv", "xls", "xlsx", "pdf", "doc", "docx"];

const isSpreadsheet = (file: File) => {
  const ext = file.name.split(".").pop()?.toLowerCase() || "";
  return ALLOWED_EXTS.includes(ext);
};

// Accept string buat <input type="file"> (spreadsheet + pdf + word)
const SPREADSHEET_ACCEPT =
  ".csv,.xls,.xlsx,.pdf,.doc,.docx," +
  "application/vnd.ms-excel," +
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet," +
  "text/csv," +
  "application/pdf," +
  "application/msword," +
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

const LelangKontrakListPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddLelangDialog, setOpenAddLelangDialog] = useState(false);
  const [openEditLelangDialog, setOpenEditLelangDialog] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingBank, setLoadingloadingBank] = useState(false);
  const [error, setError] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10); // Jumlah item per halaman
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [currentPage, setCurrentPage] = useState(1); // Halaman aktif
  const [totalPages, setTotalPages] = useState(1); // Total halaman
  const [projectOptions, setProjectOptions] = useState<ProjectOption[]>([]);
  const [rapSearchOptions, setRapSearchOptions] = useState<any[]>([]);
  const [rabOptions, setRabOptions] = useState<RabOption[]>([]);
  const [loadingRabs, setLoadingRabs] = useState(false);

  const displayedRows = rows.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  // Fungsi untuk mengambil data lelang

  // Lelang Data Table ========================================================================
  // Fungsi untuk mengambil data lelang
  const reloadLelang = async () => {
    setIsLoading(true);
    setError("");
    try {
      console.log("[LELANG] reloadLelang(): params →", {
        ...filterParams,
        limit: rowsPerPage,
        offset,
        sort: `${sortConfig.orderBy} ${sortConfig.order}`,
      });
      const result = await getLelang({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });
      console.log("[LELANG] reloadLelang(): got", result?.data?.length, "rows | total =", result?.total);

      setRows(result.data);
      setTotalItems(result.total);
      setTotalPages(result.pagination.totalPages);
    } catch (err) {
      console.error("Reload error:", err);
      setError(err.message);
      throw err; // Re-throw
    } finally {
      setIsLoading(false);
    }
  };

  const fetchRabs = async (): Promise<void> => {
    setLoadingRabs(true);
    try {
      console.log("[RAB] fetchRabs(): call getRab()");

      const result = await getRab(); // Menggunakan getRab existing tanpa modifikasi
      console.log("[RAB] fetchRabs(): raw result →", result);

      // Type assertion ke RABApiResponse
      const apiResponse = result as unknown as RABApiResponse;

      if (!apiResponse?.data || !Array.isArray(apiResponse.data)) {
        throw new Error(
          "Invalid RAB data format: Expected array in data property"
        );
      }

      const mappedOptions: RabOption[] = apiResponse.data.map((item) => ({
        id: item.id,
        rabName: item.rabName,
        totalPrice: item.totalPrice,
        project: {
          id: item.project.id,
          projectName: item.project.projectName,
          projectReferenceId: item.project.projectReferenceId,
          startDate: item.project.startDate,
          endDate: item.project.endDate,
        },
      }));

      console.log("[RAB] fetchRabs(): mapped count =", mappedOptions.length);
      console.table(mappedOptions.slice(0, 5).map(o => ({ id: o.id, rabName: o.rabName, projectId: o.project.id })));


      setRabOptions(mappedOptions);
    } catch (err) {
      console.error("Failed to fetch RABs:", err);
      Swal.fire({
        icon: "error",
        title: "Failed to load RABs",
        text: err instanceof Error ? err.message : "Please try again later",
      });
      setRabOptions([]);
    } finally {
      setLoadingRabs(false);
    }
  };

  const fetchProjectList = async () => {
    try {
      // Load from bidding view; filter awarded later
      const result = await getAllProjects();
      console.log("Raw project data from API:", result);


      // Fetch actual project names only if we truly have a UUID
      const isUUID = (val?: string) => !!val && /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/.test(val);

      const projectsWithNames = await Promise.all(
        result
          .filter((p: any) => String(p.status || p.lelangStatus || '').toLowerCase() === 'awarded')
          .map(async (project) => {
          // Prefer sales project UUID stored in projectName field
          const primary = project?.projectName;
          const fallback = project?.projectId || project?.id;
          const idCandidate = isUUID(String(primary)) ? String(primary) : (isUUID(String(fallback)) ? String(fallback) : undefined);
          if (idCandidate) {
            try {
              const projectDetails = await getProjectById(String(idCandidate));
              console.log(`Project details for ${idCandidate}:`, projectDetails);

              return {
                ...project,
                actualProjectName: projectDetails.projectName,
                salesProjectId: projectDetails.salesProjectId ?? projectDetails.id,
                lelangStatus: project.lelangStatus ?? project.status ?? "",
              };
            } catch (error) {
              console.error(`Failed to fetch project details for ${idCandidate}:`, error);
              return {
                ...project,
                actualProjectName: project.projectName,
              };
            }
          }
          return {
            ...project,
            actualProjectName: project.projectName,
          };
        })
      );
      console.log("Processed project options:", projectsWithNames);

      setProjectOptions(projectsWithNames);
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };

  const offset = (currentPage - 1) * rowsPerPage;

  const [filterParams, setFilterParams] = useState<{
    projectName?: string;
    rabName?: string;
    bidAmmount?: string;
    lelangDate?: string;
    clientName?: string;
    projectType?: string;
    constructionPhase?: string;
    projectProcess?: string;
    vendorNames?: string;
    status?: string;
    keyword?: string;
  }>({});

  // Sort
  const [sortConfig, setSortConfig] = useState<{
    orderBy: string;
    order: "asc" | "desc";
  }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };

  // Memanggil data saat komponen pertama kali dimuat
  useEffect(() => {
    reloadLelang();
    fetchProjectList();
    fetchRabs();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  // Fungsi untuk menangani pemilihan checkbox baris
  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const CustomTextField = styled(TextField)({
    "& .MuiInputBase-input": {
      backgroundColor: "#f5f5f5",
      borderRadius: 4,
      padding: "8px 12px",
    },
  });

  const handleDeleteLelang = async (confirm = true) => {
    try {
      const confirmDelete = confirm
        ? await Swal.fire({
          title: "Apakah Anda yakin?",
          text: "Anda tidak dapat mengembalikan data yang dihapus!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Ya, hapus!",
          cancelButtonText: "Batal",
        })
        : { isConfirmed: true };

      if (!confirmDelete.isConfirmed) return;

      const rowsToDelete = [...selectedRows];
      await Promise.all(rowsToDelete.map((id) => deleteLelang(String(id))));
      await Swal.fire({
        icon: "success",
        title: "Lelang berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });
      await reloadLelang(); // Biarkan reloadLelang yang handle loading state

      setSelectedRows([]);
      setOpenDeleteDialog(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus lelang",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  // 🔄 Pastikan selectedRows update setelah rows berubah
  useEffect(() => {
    setSelectedRows([]);
  }, [rows]);

  const [filters, setFilters] = useState([{ field: "projectName", value: "" }]);
  const [lelangs, setLelangs] = useState<Lelang[]>([]);

  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "projectName", label: "Project Name" },
    { value: "bidAmmount", label: "Bid Ammount" },
    { value: "lelangDate", label: "lelang Date" },
    { value: "clientName", label: "Source" },
    { value: "projectType", label: "Type" },
    { value: "constructionPhase", label: "Phase" },
    { value: "projectProcess", label: "Project Process" },
    { value: "vendorNames", label: "Vendor Names" },
    { value: "status", label: "Lelang Status" },
    { value: "contract", label: "Contract Status" },
  ];

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `ItemSearchParams`
      const searchParams: lelangSearchParams = {};

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });


      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "projectName", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
  };

  // Muat daftar project dari RAP (search_rap) saat dialog Add dibuka
  useEffect(() => {
    const loadRapProjects = async () => {
      try {
        const result: any = await getRap({ limit: 10, offset: 0, orderBy: "createdAt", order: "desc" } as RAPSearchParams);
        const list = Array.isArray(result?.data) ? result.data : [];
        setRapSearchOptions(list);
      } catch (e) {
        console.warn("[LELANG][RAP] gagal memuat search_rap:", e);
        setRapSearchOptions([]);
      }
    };
    if (openAddLelangDialog) loadRapProjects();
  }, [openAddLelangDialog]);
  const [uniqueValues, setUniqueValues] = useState<{
    projectName: string[];
    rabName: string[];
    vendorNames: string[];
  }>({
    projectName: [],
    rabName: [],
    vendorNames: [],
  });

  // Fungsi untuk mengumpulkan nilai unik dari data
  useEffect(() => {
    if (lelangs.length > 0) {
      const projectNames = [...new Set(lelangs.map((b) => b.projectName))];
      const rabNames = [...new Set(lelangs.map((b) => b.rabName))];
      const vendorNames = [
        ...new Set(lelangs.flatMap((b) => b.vendorNames || [])),
      ];

      setUniqueValues({
        projectName: projectNames,
        rabName: rabNames,
        vendorNames: vendorNames,
      });
    }
  }, [lelangs]);

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {

      setFilterParams({
        keyword: searchQuery,
      });
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      let selectedOnly = false;
      if (selectedRows.length > 0) {
        const ask = await Swal.fire({
          title: "Export",
          text: `Export ${selectedRows.length} selected rows or all (filtered) rows?`,
          showDenyButton: true,
          confirmButtonText: "Selected",
          denyButtonText: "All",
        });
        selectedOnly = ask.isConfirmed;
      }

      Swal.fire({
        title: "Preparing Export...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const exportData = await getExportData(selectedOnly);

      // Opsi 2: Export hanya data yang terlihat di tabel saat ini
      // const exportData = rows.map(formatLelangForExport);

      // Opsi 3: Export hanya data yang dipilih
      // if (selectedRows.length === 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'No Selection',
      //     text: 'Please select at least one lelang to export',
      //   });
      //   return;
      // }
      // const exportData = rows
      //   .filter(row => selectedRows.includes(row.lelangId))
      //   .map(formatLelangForExport);

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Lelangs");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Lelangs_${date}.xlsx`);

      // Tutup loading
      Swal.close();
    } catch (error) {
      console.error("Export failed:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: error.message || "Failed to export lelang data",
      });
    }
  };

  // Fungsi untuk mengambil data yang akan diexport
  const getExportData = async (selectedOnly: boolean = false) => {
    const all = selectedOnly ? { data: rows.filter((r:any) => selectedRows.includes(r.id)) } : await getLelang({
      ...filterParams,
      limit: 10000,
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    const fmt = (v: any) => (v === null || v === undefined || v === "" ? "-" : v);
    const fmtDateTime = (ts?: string) => {
      if (!ts) return "-";
      const d = new Date(ts);
      if (isNaN(d.getTime())) return "-";
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      const HH = String(d.getHours()).padStart(2, '0');
      const MM = String(d.getMinutes()).padStart(2, '0');
      const SS = String(d.getSeconds()).padStart(2, '0');
      return `${dd}/${mm}/${yyyy} ${HH}:${MM}:${SS}`;
    };

    // Ensure vendor catalog loaded (for id -> name mapping)
    let vendorCatalog = vendors;
    if (!vendorCatalog || vendorCatalog.length === 0) {
      try {
        vendorCatalog = await fetchVendors();
      } catch {}
    }

    const dataRows = Array.isArray(all?.data) ? all.data : [];
    return dataRows.map((bc: any) => {
      const loc = parseProjectLocation(bc.projectLocation || '');
      const vendorNames = Array.isArray(bc.vendorNames)
        ? bc.vendorNames
            .map((id: string) => vendorCatalog?.find(v => v.vendorId === id)?.vendorName || id)
            .join(', ')
        : fmt(bc.vendorNames);
      return {
        // Basic info (map to available fields on bidding contract)
        "Project Name": fmt(bc.projectName),
        "Client Name": fmt(bc.clientName),
        "Project ID / Reference": fmt(bc.projectId),
        "Project Type": fmt(bc.projectType),
        "Construction Phase": fmt(bc.constructionPhase),
        "Bid Amount": fmt(bc.bidAmount ?? bc.rabValue),
        "Start Date": fmt(bc.startDate),
        "End Date": fmt(bc.endDate),
        "Project Process": fmt(bc.projectProcess),
        "Vendor Names": fmt(vendorNames),
        "Lelang Status": fmt(bc.lelangStatus ?? bc.status),
        "Contract Status": fmt(bc.contractStatus),

        // Address + location parsed from projectLocation string
        "Project Address": fmt(bc.projectAddress ?? loc.address),
        Region: fmt(bc.region ?? loc.region),
        City: fmt(bc.city ?? loc.city),
        District: fmt(bc.district ?? loc.district),
        Longitude: fmt(bc.longitude ?? loc.longitude),
        Latitude: fmt(bc.latitude ?? loc.latitude),

        // Audit
        "Tanggal Dibuat": fmtDateTime(bc.createdAt),
        "Tanggal Diupdate": fmtDateTime(bc.updatedAt ?? bc.updateAt),
      };
    });
  };

  // Fungsi untuk memformat data lelang untuk export
  const formatLelangForExport = (lelang) => ({
    lelangId: lelang.lelangId,
    lelangNameame: lelang.lelangNameame,
    lelangAddress: lelang.lelangAddress,
    lelangType: lelang.lelangType,
    lelangContactNumber: lelang.lelangContactNumber,
    lelangEmail: lelang.lelangEmail,
    lelangStatus: lelang.lelangStatus,
    // ... tambahkan field lainnya sesuai kebutuhan
  });

  // add lelang data ========================================================================
  const [lelangDataAdd, setLelangDataAdd] = useState<{
    id: string;
    projectListingId: string;
    projectName: string;
    clientName: string;
    rabId: string;
    projectId: string;
    projectType: string;
    constructionPhase: string;
    rabName: string;
    lelangDate: Date | null;
    projectAddress: string;
    rabValue: number;
    startDate: string;
    endDate: string;
    projectProcess: string;
    salesProjectId: string;
    vendorNames: any[];
    vendorProjectValue: any[];
    vendorDocument: any[],
    lelangStatus: string;
    lelangRegion: string;
    lelangCity: string;
    lelangDistrict: string;
    latitude: string;
    longitude: string;
    lelangFile: File | null;
    contractStatus: string;
  }>({
    id: "",
    projectListingId: "",
    projectName: "",
    clientName: "",
    rabId: "",
    projectId: "",
    salesProjectId: "",
    projectType: "",
    constructionPhase: "",
    rabName: "",
    lelangDate: null,
    projectAddress: "",
    rabValue: 0,
    startDate: "",
    endDate: "",
    projectProcess: "",
    vendorNames: [""],
    vendorProjectValue: [""],
    lelangStatus: "",
    lelangFile: null as File | null,     // <— ganti dari `file`
    vendorDocument: [] as string[],
    lelangRegion: "",
    lelangCity: "",
    lelangDistrict: "",
    latitude: "",
    longitude: "",
    contractStatus: "",
  });

  const nullProject = {
    id: "",
    source: "",
    projectListingId: "",
    projectName: "",
    projectAddress: "",
    rabId: "",
    projectId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  };

  const nullRab = {
    id: "",
    rabName: "",
    totalPrice: "",
    projectId: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  };

  const [projectAdd, setProjectAdd] = useState<{
    id: string;
    source: string;
    projectListingId: string;
    projectName: string;
    projectAddress: string;
    projectId: string;
    city: string;
    region: string;
    district: string;
    latitude: string;
    longitude: string;
    constructionPhase: string;
    salesProjectId: string;
    valueEstimation?: string;
    projectType: string;
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    source: "",
    projectListingId: "",
    projectName: "",
    projectAddress: "",
    projectId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [rabAdd, setRabAdd] = useState<{
    id: string;
    rabName: string;
    totalPrice: string;
    startDate: string;
    endDate: string;
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    rabName: "",
    totalPrice: "",
    startDate: "",
    endDate: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [loadingVendors, setLoadingVendors] = useState(false);
  const [projectNames, setProjectNames] = useState<{ [key: string]: string }>({});
  const [rabDetails, setRabDetails] = useState<any[]>([]);

  // Function to parse projectLocation string
  const parseProjectLocation = (projectLocation?: string) => {
    const result = {
      address: "",
      longitude: "",
      latitude: "",
      region: "",
      city: "",
      district: ""
    };

    if (!projectLocation) return result;

    // Parse Address - take everything between "Address :"/"Address:" and ", Long :"
    const addressMatch = projectLocation.match(/Address\s*:\s*([^,]+(?:,[^,]+)*?)(?=,\s*Long\s*:\s*)/);
    if (addressMatch) {
      result.address = addressMatch[1].trim();
    }

    // Parse Longitude
    const longMatch = projectLocation.match(/Long\s*:\s*([^,]+)/);
    if (longMatch) {
      result.longitude = longMatch[1].trim();
    }

    // Parse Latitude
    const latMatch = projectLocation.match(/Lat\s*:\s*([^,]+)/);
    if (latMatch) {
      result.latitude = latMatch[1].trim();
    }

    // Parse Region
    const regionMatch = projectLocation.match(/Region\s*:\s*([^,]+)/);
    if (regionMatch) {
      result.region = regionMatch[1].trim();
    }

    // Parse City
    const cityMatch = projectLocation.match(/City\s*:\s*([^,]+)/);
    if (cityMatch) {
      result.city = cityMatch[1].trim();
    }

    // Parse District
    const districtMatch = projectLocation.match(/District\s*:\s*([^,]+)/);
    if (districtMatch) {
      result.district = districtMatch[1].trim();
    }

    return result;
  };

  const resetAddForm = () => {
    setLelangDataAdd({
      id: "",
      projectListingId: "",
      projectName: "",
      clientName: "",
      rabId: "",
      projectId: "",
      projectType: "",
      constructionPhase: "",
      rabName: "",
      lelangDate: null,
      projectAddress: "",
      rabValue: 0,
      startDate: "",
      endDate: "",
      projectProcess: "",
      vendorNames: [""],
      vendorProjectValue: [""],
      vendorDocument: [],
      contractStatus: "",
      lelangRegion: "",
      lelangCity: "",
      lelangDistrict: "",
      lelangStatus: "",
      latitude: "",
      longitude: "",
      lelangFile: null,
      salesProjectId: "",
    });
    setLelangFilePreview("");
    // setVendorDocs([]);
    setVendorDocs([[]]); // kosongkan, 1 slot vendor awal
    setVendorStatuses([""]);   // <— tambah ini

  };

  const handleProjectChange = async (e) => {
    const projectId = e.target.value; // This will be the project's id (not referenceId)

    console.log("Selected project ID:", projectId);
    const selectedProject = projectOptions.find(
      (proj) => proj.id === projectId
    );
    console.log("Full selected project object:", selectedProject);


    if (selectedProject) {
      try {
        // Use actualProjectName if available, otherwise use projectName
        const actualProjectName = selectedProject.actualProjectName || selectedProject.projectName;
        console.log("Vendor data from selected project:", {
          vendorNames: selectedProject.vendorNames,
          vendorProjectValue: selectedProject.vendorProjectValue
        });

        const vendorDetails = await Promise.all(
          selectedProject.vendorNames.map(async (vendorId) => {
            try {
              const vendor = vendors.find(v => v.vendorId === vendorId);
              return {
                id: vendorId,
                name: vendor ? vendor.vendorName : `Unknown Vendor (${vendorId})`,
                value: selectedProject.vendorProjectValue[selectedProject.vendorNames.indexOf(vendorId)] || "0"
              };
            } catch (error) {
              console.error(`Failed to get vendor details for ${vendorId}`, error);
              return {
                id: vendorId,
                name: `Error Loading Vendor (${vendorId})`,
                value: "0"
              };
            }
          })
        );

        console.log("Processed vendor details:", vendorDetails);
        // Parse projectLocation from view_bidding data
        const locationData = parseProjectLocation(selectedProject.projectLocation);

        // Get actual RAB name if rabName is an ID
        let actualRabName = selectedProject.rabName;
        if (selectedProject.rabName && selectedProject.rabName.length > 20) {
          const foundRab = rabOptions.find(rab => rab.id === selectedProject.rabName);
          if (foundRab) {
            actualRabName = foundRab.rabName;
          } else {
            // If not found in rabOptions, try to fetch from API
            try {
              // You might need to create a function to get RAB by ID
              // For now, we'll use the ID as fallback
              actualRabName = selectedProject.rabName;
            } catch (error) {
              console.error("Failed to fetch RAB details:", error);
              actualRabName = selectedProject.rabName;
            }
          }
        }

        // Auto-populate RAB data based on selected project
        const projectRabs = rabOptions.filter(rab => rab.project.id === selectedProject.id);
        const defaultRab = projectRabs.length > 0 ? projectRabs[0] : null;

        // Auto-populate vendor data (you can modify this logic based on your requirements)
        const defaultVendors = vendors.slice(0, 2); // Get first 2 vendors as default
        const defaultVendorIds = defaultVendors.map(v => v.vendorId);
        const defaultVendorValues = defaultVendors.map(v => "0"); // Default values

        setLelangDataAdd((prev) => ({
          ...prev,
          projectId: selectedProject.projectId || selectedProject.projectReferenceId,
          projectListingId: selectedProject.id,
          projectName: actualProjectName,
          clientName: selectedProject.clientName || "", // Ensure clientName is always a string
          projectType: selectedProject.projectType,
          constructionPhase: selectedProject.constructionPhase,
          projectAddress: locationData.address,
          latitude: locationData.latitude,
          longitude: locationData.longitude,
          lelangRegion: locationData.region,
          lelangCity: locationData.city,
          lelangDistrict: locationData.district,
          // Auto-populate RAB data from view_bidding
          rabId: selectedProject.rabName || "", // This is the RAB ID
          rabName: actualRabName || "", // Use the actual RAB name, ensuring it's always a string
          rabValue: selectedProject.rabValue ? parseFloat(selectedProject.rabValue) || 0 : 0,
          startDate: selectedProject.startDate || "",
          endDate: selectedProject.endDate || "",
          // Auto-populate lelang date (current date + 30 days as default)
          lelangDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
          // Auto-populate project process from view_bidding
          projectProcess: selectedProject.projectProcess || "",
          // Auto-populate vendor data
          vendorNames: vendorDetails.map(v => v.id),
          vendorProjectValue: vendorDetails.map(v => v.value),
          vendorDisplay: vendorDetails,
          // Auto-populate status
          lelangStatus: selectedProject.lelangStatus || "",
          // Use sales project UUID stored in projectName from view_bidding
          salesProjectId: selectedProject.projectName || ""
        }));

        setVendorDocs(Array.from({ length: vendorDetails.length }, () => []));
        setVendorStatuses(
          Array.from({ length: vendorDetails.length }, () => selectedProject.lelangStatus || "")
        );
      } catch (error) {
        console.error("Error handling project change:", error);
      }
    } else {
      // Reset all fields if no project selected
      setLelangDataAdd((prev) => ({
        ...prev,
        projectId: "",
        projectListingId: "",
        projectName: "",
        clientName: "",
        projectType: "",
        constructionPhase: "",
        projectAddress: "",
        latitude: "",
        longitude: "",
        lelangRegion: "",
        lelangCity: "",
        lelangDistrict: "",
        rabId: "",
        rabName: "",
        rabValue: 0,
        startDate: "",
        endDate: "",
        lelangDate: null,
        projectProcess: "",
        vendorNames: [""],
        vendorProjectValue: [""],
        lelangStatus: "",
      }));
    }
  };

  const handleLelangFileUpload = (file: File) => {
    if (!file) return;
    if (!isSpreadsheet(file) || file.size > MAX_UPLOAD_SIZE) {
      Swal.fire({ icon: "error", title: "File lelang harus CSV/XLS/XLSX ≤ 2MB" });
      return;
    }
    setLelangFilePreview("spreadsheet_uploaded");
    setLelangDataAdd((prev) => ({ ...prev, lelangFile: file }));
  };

  // Handler upload multi file
  const handleVendorDocsUpload = (files: FileList) => {
    const validFiles = Array.from(files).filter(
      (file) => isSpreadsheet(file) && file.size <= MAX_UPLOAD_SIZE
    );

    if (validFiles.length !== files.length) {
      Swal.fire({ icon: "error", title: "Hanya CSV/XLS/XLSX ≤ 2MB yang diizinkan" });
    }

    // Append as a new vendor slot (File[]), keeping File[][] type
    setVendorDocs(prev => [...prev, validFiles]);
    setLelangDataAdd(prev => ({
      ...prev,
      vendorDocument: [
        ...(prev.vendorDocument || []),
        ...validFiles.map(f => f.name)
      ]
    }));
  };



  const handleVendorStatusChange = (index: number, value: string) => {
    setVendorStatuses(prev => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
    // jaga kompatibilitas: isi lelangStatus global dengan status vendor pertama
    if (index === 0) {
      setLelangDataAdd(prev => ({ ...prev, lelangStatus: value }));
    }
  };

  const handleVendorDocsUploadByIndex = (vendorIndex: number, files: FileList) => {
    const picked = Array.from(files).filter(
      (f) => isSpreadsheet(f) && f.size <= MAX_UPLOAD_SIZE
    );
    if (picked.length !== files.length) {
      Swal.fire({ icon: "error", title: "Hanya CSV/XLS/XLSX ≤ 2MB yang diizinkan" });
    }

    setVendorDocs(prev => {
      const next = [...prev];
      next[vendorIndex] = [...(next[vendorIndex] || []), ...picked];
      return next;
    });

    // simpan NAMA file ke payload (backend tidak mau array/object random)
    setLelangDataAdd(prev => ({
      ...prev,
      vendorDocument: [
        // gabung semua nama file dari semua vendor ke satu list nama (nanti di-join saat create)
        ...new Set([
          ...(Array.isArray(prev.vendorDocument) ? prev.vendorDocument : []),
          ...picked.map(f => f.name),
        ]),
      ],
    }));
  };

  // Hapus file vendor docs
  const removeVendorDoc = (idx: number) => {
    setVendorDocs(prev => prev.filter((_, i) => i !== idx));
    setLelangDataAdd(prev => ({
      ...prev,
      vendorDocument: prev.vendorDocument.filter((_, i) => i !== idx)
    }));
  };

  const handleOpenAddDialog = () => {
    resetAddForm();
    setOpenAddLelangDialog(true);
  };

  const handleInputChangeAdd = (e) => {
    const { name, value } = e.target;
    setLelangDataAdd({ ...lelangDataAdd, [name]: value });
  };

  const [errorsAdd, setErrorsAdd] = useState({
    projectName: false,
    rabName: false,
    lelangDate: false,
    projectProcess: false,
    vendorNames: false,
    vendorProjectValue: false,
    lelangStatus: false,
  });

  const validateFormAdd = () => {
    let newErrors = {
      projectName: !lelangDataAdd.projectName,
      rabName: !lelangDataAdd.rabName,
      lelangDate: !lelangDataAdd.lelangDate,
      projectProcess: !lelangDataAdd.projectProcess,
      vendorNames: !lelangDataAdd.vendorNames,
      vendorProjectValue: !lelangDataAdd.vendorProjectValue,
      lelangStatus: vendorStatuses.some(s => !s), // <— wajib terisi per vendor
    };
    setErrorsAdd(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const showPopupMandatoryError = () => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: "Lengkapi data yang wajib diisi.",
    });
  };

  const handleVendorChangeAdd = (index: number, vendorId: string) => {
    setLelangDataAdd((prev) => {
      const newVendorNames = [...prev.vendorNames];
      newVendorNames[index] = vendorId;

      // Ensure vendorProjectValue array exists and has same length
      const newVendorProjectValue = Array.isArray(prev.vendorProjectValue)
        ? [...prev.vendorProjectValue]
        : new Array(prev.vendorNames.length).fill("");

      return {
        ...prev,
        vendorNames: newVendorNames,
        vendorProjectValue: newVendorProjectValue,
      };
    });
  };

  const handleProjectValueChangeAdd = (index: number, value: string) => {
    setLelangDataAdd((prev) => {
      // Handle baik untuk array maupun nilai tunggal
      const newValues = Array.isArray(prev.vendorProjectValue)
        ? [...prev.vendorProjectValue]
        : prev.vendorProjectValue
          ? [prev.vendorProjectValue]
          : [""];

      newValues[index] = value;

      return {
        ...prev,
        vendorProjectValue: newValues,
      };
    });
  };

  const addVendorField = () => {
    setLelangDataAdd(prev => ({
      ...prev,
      vendorNames: [...prev.vendorNames, ""],
      vendorProjectValue: [
        ...(Array.isArray(prev.vendorProjectValue) ? prev.vendorProjectValue : [prev.vendorProjectValue || ""]),
        ""
      ],
    }));
    setVendorDocs(prev => [...prev, []]);                // slot dokumen vendor baru
    setVendorStatuses(prev => [...prev, prev[0] || ""]); // default ambil dari vendor pertama
  };

  const removeVendorField = (index: number) => {
    setLelangDataAdd(prev => ({
      ...prev,
      vendorNames: prev.vendorNames.filter((_, i) => i !== index),
      vendorProjectValue: (Array.isArray(prev.vendorProjectValue) ? prev.vendorProjectValue : [prev.vendorProjectValue || ""])
        .filter((_, i) => i !== index),
    }));
    setVendorDocs(prev => prev.filter((_, i) => i !== index));
    setVendorStatuses(prev => prev.filter((_, i) => i !== index));
  };


  const handleSaveAdd = async () => {
    try {
      // Filter vendor yang valid
      const validVendorEntries = lelangDataAdd.vendorNames
        .map((vendorId, index) => ({
          vendorId,
          projectValue: lelangDataAdd.vendorProjectValue[index],
        }))
        .filter((entry) => entry.vendorId && entry.projectValue);

      if (validVendorEntries.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Vendor Required",
          text: "Please select at least one vendor with project value",
          confirmButtonColor: "#0F62FE",
        });
        return;
      }

      if (!validateFormAdd()) {
        showPopupMandatoryError();
        return;
      }

      const lelangStatusStr = vendorStatuses
        .filter(Boolean)
        .join(", ");

      // === PATCH: Pastikan field lokasi dikirim satu per satu ===
      const payload = {
        ...lelangDataAdd,
        vendorNames: validVendorEntries.map((entry) => entry.vendorId),
        vendorProjectValue: validVendorEntries.map((entry) => entry.projectValue),
        lelangStatus: lelangStatusStr, // <— kirim sebagai string gabungan
        salesProjectId: lelangDataAdd.salesProjectId,
        // Jangan kirim nama file asli; biarkan upload endpoint mengembalikan key terenkripsi
        vendorDocument: [],
        contractStatus: lelangDataAdd.contractStatus,
      };


      // LOG PAYLOAD
      console.log('=== [Lelang] Payload yang dikirim ke backend ===');
      console.log(JSON.stringify(payload, null, 2));
      // Step 1: Create lelang
      const response = await createLelang(payload);

      // LOG RESPONSE
      console.log('=== [Lelang] Response dari backend setelah create ===');
      console.log(JSON.stringify(response, null, 2));
      // Step 2: Upload proposal file if available
      let biddingKey: string | null = null;
      if (lelangDataAdd.lelangFile) {
        const res = await uploadProposal(response.id, lelangDataAdd.lelangFile, "biddingFile");
        if (res?.file) biddingKey = res.file; // encrypted key from backend
      }

      // upload semua vendor docs (per vendor)
      // for (const filesOfVendor of vendorDocs) {
      //   for (const file of filesOfVendor) {
      //     await uploadProposal(response.id, file, "vendorDocument");
      //   }
      // }


      const uploadedKeys: string[] = [];
      for (const filesOfVendor of vendorDocs) {
        for (const file of filesOfVendor) {
          const res = await uploadProposal(response.id, file, "vendorDocument");
          if (res?.file) uploadedKeys.push(res.file);
        }
      }

      // Step 3: Update lagi kolom file di DB (vendorDocument dan/atau biddingFile)
      if (uploadedKeys.length > 0 || biddingKey) {
        await updateLelang({
          id: response.id,
          vendorNames: lelangDataAdd.vendorNames,
          vendorProjectValue: lelangDataAdd.vendorProjectValue,
          vendorDocument: uploadedKeys,
          ...(biddingKey ? { biddingFile: biddingKey } : {}),
        });
      }

      Swal.fire({
        icon: "success",
        title: "Lelang berhasil ditambahkan",
        confirmButtonColor: "#0F62FE",
      });

      setOpenAddLelangDialog(false);
      reloadLelang();
      resetAddForm();
    } catch (error) {
      // (error handler: copy as-is dari code kamu)
      let errorTitle = "Gagal membuat Lelang";
      let errorDetails = "";

      if (error.response?.data) {
        const backendError = error.response.data;
        console.log(
          "Backend Error Structure:",
          JSON.stringify(backendError, null, 2)
        );
        errorTitle = backendError.error || errorTitle;

        const isEmailValidationError =
          (backendError.details &&
            /validation isEmail on (email|lelangEmail)/i.test(
              backendError.details
            )) ||
          (backendError.errors &&
            backendError.errors.some(
              (err) =>
                (err.path === "email" || err.path === "lelangEmail") &&
                err.validatorKey === "isEmail"
            )) ||
          (backendError.message && /email.*invalid/i.test(backendError.message));

        if (isEmailValidationError) {
          errorTitle = "Format Email Tidak Valid";
          errorDetails =
            "• Format email tidak valid (contoh: nama@perusahaan.com)";
        } else if (backendError.details) {
          errorDetails = backendError.details;
        }

        if (backendError.errors) {
          const validationMessages = backendError.errors
            .map((err) => {
              const errorObj = Array.isArray(err) ? err[0] : err;
              if (
                (errorObj.path === "email" ||
                  errorObj.path === "lelangEmail") &&
                errorObj.validatorKey === "isEmail"
              ) {
                return null;
              }
              return `• ${errorObj.message || "Terjadi kesalahan validasi"}`;
            })
            .filter(Boolean)
            .join("\n");

          if (validationMessages) {
            errorDetails = errorDetails
              ? `${errorDetails}\n${validationMessages}`
              : validationMessages;
          }
        }

        if (backendError.duplicates) {
          const duplicateMessages = backendError.duplicates
            .map((dup) => `• ${dup.field}: ${dup.value} sudah terdaftar`)
            .join("\n");

          if (duplicateMessages) {
            errorDetails = errorDetails
              ? `${errorDetails}\n${duplicateMessages}`
              : duplicateMessages;
          }
        }
      } else {
        errorDetails = error.message || "Terjadi kesalahan jaringan atau server";
      }

      Swal.fire({
        icon: "error",
        title: errorTitle,
        html: `
          <div style="text-align: left;">
            <p style="font-weight: bold; margin-bottom: 10px; color: #d32f2f;">
              ${errorTitle}
            </p>
            ${errorDetails
            ? `<div style="
                    color: #5f2120;
                    background: #fdecea;
                    padding: 12px;
                    border-radius: 4px;
                    font-size: 0.9em;
                    border-left: 4px solid #d32f2f;
                    line-height: 1.5;
                  ">
                    ${errorDetails.replace(/\n/g, "<br>")}
                  </div>`
            : ""
          }
          </div>
        `,
        confirmButtonColor: "#0F62FE",
        width: "600px",
      });
    }
  };


  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  // const [previewUrl, setPreviewUrl] = useState<string>("");
  const [lelangFilePreview, setLelangFilePreview] = useState<string>("");
  const [vendorDocs, setVendorDocs] = useState<File[][]>([[]]);
  const [vendorStatuses, setVendorStatuses] = useState<string[]>([""]);



  const lelangFileInputRef = useRef<HTMLInputElement>(null);
  const vendorDocsInputRef = useRef<HTMLInputElement>(null);

  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleCloseAdd = () => {
    setOpenAddLelangDialog(false);
    resetAddForm(); // Reset form saat ditutup
  };

  useEffect(() => {
    const loadVendors = async () => {
      setLoadingVendors(true);
      try {
        const vendorsData = await fetchVendors();
        setVendors(vendorsData);
      } catch (error) {
        console.error("Gagal memuat vendors:", error);
      } finally {
        setLoadingVendors(false);
      }
    };

    loadVendors();
  }, []);

  //edit lelang data ========================================================================
  const [isEditing, setIsEditing] = useState(false);
  const [vendorStatusesEdit, setVendorStatusesEdit] = useState<string[]>([]);
  const [vendorDocsEdit, setVendorDocsEdit] = useState<File[][]>([]);

  const [existingVendorDocsEdit, setExistingVendorDocsEdit] = useState<string[]>([]);


  const splitStatusToArray = (s: string, len: number) => {
    const arr = (s || "").split(",").map(x => x.trim()).filter(Boolean);
    return Array.from({ length: len || 1 }, (_, i) => arr[i] || "");
  };

  const [selectedLelangId, setSelectedLelangId] = useState<number | null>(
    null
  );
  const [lelangDataEdit, setLelangDataEdit] = useState<{
    id: string;
    projectListingId: string;
    projectName: string;
    clientName: string;
    rabId: string;
    projectId: string;
    projectType: string;
    constructionPhase: string;
    rabName: string;
    lelangDate: Date | null;
    projectAddress: string;
    rabValue: number;
    startDate: string;
    endDate: string;
    projectProcess: string;
    vendorNames: any[];
    vendorProjectValue: any[];
    lelangStatus: string;
    lelangAddress: string;
    lelangRegion: string;
    lelangCity: string;
    lelangDistrict: string;
    latitude: string;
    longitude: string;
    file: File | null;
    previewUrl: string; // Add this
    vendorProposalUrl: string;
    contractStatus: string;
  }>({
    id: "",
    projectListingId: "",
    projectName: "",
    clientName: "",
    rabId: "",
    projectId: "",
    projectType: "",
    constructionPhase: "",
    rabName: "",
    lelangDate: null,
    projectAddress: "",
    rabValue: 0,
    startDate: "",
    endDate: "",
    projectProcess: "",
    vendorNames: [""],
    vendorProjectValue: [""],
    lelangStatus: "",
    lelangAddress: "",
    lelangRegion: "",
    lelangCity: "",
    lelangDistrict: "",
    latitude: "",
    longitude: "",
  file: null,
  previewUrl: "", // Add this
  vendorProposalUrl: "",
  contractStatus: "",
});

  const resolveVendorName = (vendorId: string) => {
    if (!vendorId) return "";
    const vendor = vendors.find((v) => v.vendorId === vendorId);
    return vendor?.vendorName || vendorId;
  };

  const buildVendorDocDisplayName = (
    docName: string,
    index: number,
    mode: "add" | "edit"
  ) => {
    const rawProjectName =
      mode === "edit"
        ? (lelangDataEdit?.projectName || lelangDataEdit?.projectListingId || "")
        : (lelangDataAdd?.projectName || lelangDataAdd?.projectListingId || "");

    const vendorId =
      mode === "edit"
        ? (lelangDataEdit?.vendorNames || [])[index] || ""
        : (lelangDataAdd?.vendorNames || [])[index] || "";

    const vendorName = resolveVendorName(vendorId);

    const sanitizePart = (value: string) =>
      value
        ? value
            .toString()
            .trim()
            .replace(/\s+/g, "_")
            .replace(/_+/g, "_")
        : "";

    const projectPart = sanitizePart(rawProjectName);
    const vendorPart = sanitizePart(vendorName);

    if (!projectPart && !vendorPart) {
      return "vendor";
    }

    if (projectPart && !vendorPart) {
      return `vendor_${projectPart}`;
    }

    if (!projectPart && vendorPart) {
      return `vendor_${vendorPart}`;
    }

    return `vendor_${projectPart}_${vendorPart}`;
  };

  const handleDownload = async (filename: string, vendorIndex?: number) => {
    try {
      // Normalisasi filename: jika mengandung koma ("original,stored"), ambil bagian terakhir (stored key)
      const normalized = typeof filename === 'string'
        ? (filename.includes(',')
            ? filename.split(',').map(s => s.trim()).filter(Boolean).pop() || filename
            : filename)
        : String(filename);

      const { blob } = await getProposalFile(normalized);

      // Format tanggal saat ini menjadi DD-MM-YYYY
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, "0")}-${(
        today.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${today.getFullYear()}`;

      // Cari project dengan logika yang sama seperti di Autocomplete
      const selectedProject =
        projectOptions.find((opt) => opt.id === lelangDataEdit.projectListingId) ||
        projectOptions.find((opt) => opt.projectName === lelangDataEdit.projectName);

      // Gunakan nama project yang benar; fallback jika tidak ada
      const projectName = (
        selectedProject?.actualProjectName ||
        selectedProject?.projectName ||
        lelangDataEdit.projectName ||
        "Unknown Project"
      );

      // Buat nama file baru
      const getExt = (name?: string) =>
        name && name.includes(".") ? name.split(".").pop()!.toLowerCase() : "xlsx";
      const getBase = (name?: string) =>
        name ? name.replace(/^.*[\\\/]/, "").replace(/\.[^/.]+$/, "") : "file";

      const isLelangFile = normalized === lelangDataEdit.vendorProposalUrl;
      const ext = getExt(normalized);
      const safeProject = projectName
        .replace(/\s+/g, "_")
        .replace(/[^a-zA-Z0-9_]/g, "")
        .substring(0, 50);

      let newFilename: string;

      if (isLelangFile) {
        newFilename = `File Lelang_${safeProject}_${formattedDate}.${ext}`;
      } else {
        let derivedIndex = typeof vendorIndex === "number" ? vendorIndex : -1;

        if (derivedIndex < 0) {
          const existingIndex = (existingVendorDocsEdit || []).findIndex((doc) => doc === filename);
          derivedIndex = existingIndex >= 0 ? existingIndex : 0;
        }

        const displayName = buildVendorDocDisplayName(
          normalized,
          derivedIndex,
          "edit"
        );
        newFilename = `${displayName}.${ext}`;
      }

      // Buat URL untuk blob
      const url = window.URL.createObjectURL(blob);

      // Buat elemen anchor untuk download
      const a = document.createElement("a");
      a.href = url;
      a.download = newFilename;
      document.body.appendChild(a);
      a.click();

      // Bersihkan
      window.URL.revokeObjectURL(url);
      a.remove();
    } catch (error) {
      console.error("Download error:", error);
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text:
          error instanceof Error ? error.message : "Failed to download file",
      });
    }
  };


  const handleOpenEditDialog = async (row: any) => {
    try {
      console.log("[EDIT-DIALOG] open with row →", {
        id: row?.id,
        projectName: row?.projectName,
        rawRabId: row?.rabId,
        rawRabName: row?.rabName,
      });

      console.log("[EDIT-DIALOG] Data row dari table →", row);
      // === DEBUG: View Details Lelang ===
      try {
        console.log(`[VIEW DETAILS] lelang id = ${row?.id}`);
        console.log("[VIEW DETAILS] raw row JSON →", JSON.stringify(row, null, 2));
      } catch (e) {
        console.warn("[VIEW DETAILS] stringify row failed", e);
      }
      console.log("[EDIT-DIALOG] biddingFile →", row?.biddingFile);
      console.log("[EDIT-DIALOG] vendorDocument →", row?.vendorDocument);

      // --- ambil file proposal ---
      // Normalisasi fileId (bisa berupa array, atau string gabungan "original,stored")
      const rawFileId = row?.biddingFile;
      const fileId = Array.isArray(rawFileId)
        ? rawFileId.filter(Boolean).pop()
        : (typeof rawFileId === 'string'
            ? (rawFileId.includes(',')
                ? rawFileId.split(',').map((s: string) => s.trim()).filter(Boolean).pop()
                : rawFileId)
            : '');
      let previewUrl = "";
      let fileObject: File | null = null;
      if (fileId) {
        try {
          const { blob } = await getProposalFile(fileId);
          previewUrl = URL.createObjectURL(blob);
          fileObject = new File([blob], fileId, { type: blob.type || "application/octet-stream" });
        } catch (e) {
          console.warn("Gagal ambil file proposal:", e);
        }
      }

      // --- vendor arrays ---
      const vendorNames = Array.isArray(row.vendorNames)
        ? row.vendorNames
        : row.vendorNames ? [row.vendorNames] : [];

      // Normalisasi vendorProjectValue agar selalu array selaras dengan vendorNames
      let vendorValues: (string | number)[] = [];
      if (Array.isArray(row.vendorProjectValue)) {
        vendorValues = row.vendorProjectValue.map((v: any) =>
          typeof v === 'object' && v !== null ? '' : v
        );
      } else if (row.vendorProjectValue && typeof row.vendorProjectValue === 'string') {
        // Coba parse jika berupa JSON string mapping
        try {
          const parsed = JSON.parse(row.vendorProjectValue);
          if (parsed && typeof parsed === 'object') {
            vendorValues = vendorNames.map((id: string) => {
              const val = parsed[id];
              return val === undefined || val === null ? '' : val;
            });
          } else {
            vendorValues = [row.vendorProjectValue];
          }
        } catch {
          vendorValues = [row.vendorProjectValue];
        }
      } else if (
        row.vendorProjectValue &&
        typeof row.vendorProjectValue === 'object'
      ) {
        // Jika berupa object mapping { vendorId: value }
        vendorValues = vendorNames.map((id: string) => {
          const val = row.vendorProjectValue[id];
          return val === undefined || val === null ? '' : val;
        });
      } else if (row.vendorProjectValue !== undefined && row.vendorProjectValue !== null) {
        vendorValues = [row.vendorProjectValue];
      } else {
        vendorValues = vendorNames.map(() => '');
      }

      const sts = (row.lelangStatus || "")
        .split(",")
        .map((s: string) => s.trim())
        .filter(Boolean);
      const vendorStatusesArr = Array.from({ length: vendorNames.length || 1 }, (_, i) => sts[i] || "");
      console.log("[VIEW DETAILS] vendor count =", vendorNames.length);

      console.log("[VENDOR DOCS] raw row.vendorDocument →", row.vendorDocument);

      // --- vendor documents ---
      let existingDocs: string[] = [];
      if (Array.isArray(row.vendorDocument)) {
        // Preserve positions; map null/undefined to empty string
        existingDocs = row.vendorDocument.map((x: any) => (x == null ? '' : String(x)));
      } else if (typeof row.vendorDocument === 'string') {
        const trimmed = row.vendorDocument.trim();
        if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
          try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) {
              existingDocs = parsed.map((x: any) => (x == null ? '' : String(x)));
            }
          } catch {
            // fallback to comma-split below
          }
        }
        if (existingDocs.length === 0) {
          // CSV fallback (cannot represent empties reliably). Keep whatever is present.
          existingDocs = trimmed
            .split(',')
            .map((s: string) => s.trim());
        }
      }

      console.log("[VENDOR DOCS] parsed existingDocs array →", existingDocs);

      // Map existing docs to vendor indices (1 doc per vendor)
      const normalizedDocs = vendorNames.map((_, idx) => existingDocs[idx] || "");
      try {
        const vendorOverview = vendorNames.map((id: any, idx: number) => ({
          index: idx,
          vendorId: id,
          value: (vendorValues || [])[idx],
          status: (vendorStatusesArr || [])[idx],
          doc: normalizedDocs[idx] || "",
        }));
        console.log("[VIEW DETAILS] vendors overview →", vendorOverview);
        console.table(vendorOverview);
      } catch (e) {
        console.warn("[VIEW DETAILS] overview log failed", e);
      }

      const vendorFiles: File[] = [];
      const vendorDocUrls: { name: string; url: string }[] = [];

      // Only fetch documents that are mapped to a vendor index
      for (const doc of normalizedDocs) {
        try {
          if (!doc) continue; // guard: skip empty slot
          // normalisasi: jika ada "original,stored", pakai yang terakhir (stored key)
          const norm = doc.includes(',')
            ? doc.split(',').map((s: string) => s.trim()).filter(Boolean).pop() || doc
            : doc;

          console.log(`[VENDOR DOCS] fetching blob for → ${norm}`);
          const { blob } = await getProposalFile(norm);

          const fileObj = new File([blob], norm, { type: blob.type || "application/octet-stream" });
          vendorFiles.push(fileObj);

          vendorDocUrls.push({ name: norm, url: URL.createObjectURL(blob) });

          console.log(`[VENDOR DOCS] success → ${doc}, blob size =`, blob.size);
        } catch (e) {
          console.warn("Gagal ambil vendor doc:", doc, e);
        }
      }

      console.log("[VENDOR DOCS] final vendorDocUrls →", vendorDocUrls);

      // --- RAB resolve ---
      console.log("[EDIT-DIALOG] current rabOptions →", rabOptions);

      const rabIdFromRow = row?.rabId || row?.rabName || "";
      let matchedRab = rabOptions.find((r: any) => r.id === rabIdFromRow);

      if (!matchedRab && rabOptions.length > 0) {
        matchedRab = rabOptions[0];
        console.log("[EDIT-DIALOG] fallback ke rabOptions[0] →", matchedRab);
      }

      // derive selected project for display name
      const selectedProj =
        projectOptions.find((opt) => opt.id === row.projectName) ||
        projectOptions.find((opt) => opt.projectName === row.projectName);

      // set data utama
      setLelangDataEdit({
        id: row.id,
        projectListingId: row.projectName,
        projectName: selectedProj?.actualProjectName || selectedProj?.projectName || row.projectName || "",
        clientName: row.clientName || "",
        projectId: row.projectId || "",
        projectType: row.projectType || "",
        constructionPhase: row.constructionPhase || "",
        rabId: matchedRab?.id || "",
        rabName: matchedRab?.rabName || "",
        rabValue: row.bidAmount ? Number(row.bidAmount) : 0,
        lelangDate: row.lelangDate || "",
        startDate: row.startDate || "",
        endDate: row.endDate || "",
        projectAddress: row.projectAddress || "",
        latitude: row.latitude || "",
        longitude: row.longitude || "",
        lelangRegion: row.region || "",
        lelangCity: row.city || "",
        lelangDistrict: row.district || "",
        projectProcess: row.projectProcess || "",
        vendorNames,
        vendorProjectValue: vendorValues,
        lelangStatus: row.lelangStatus || "",
        file: null,
        previewUrl,
        vendorProposalUrl: fileId || "",
        contractStatus: row.contractStatus || "",
      } as any);
      console.log("[VIEW DETAILS] lelangDataEdit has been set.");

      setVendorStatusesEdit(vendorStatusesArr);

      const vendorDocsPerVendor: File[][] = vendorNames.map((_, idx) => {
        const docName = normalizedDocs[idx];
        if (!docName) return [];
        const fileObj = vendorFiles.find((f) => f.name === docName);
        return fileObj ? [fileObj] : [];
      });
      // taruh hasil fetch vendor docs ke state
      setVendorDocsEdit(vendorDocsPerVendor);
      setExistingVendorDocsEdit(normalizedDocs);
      console.log("[VIEW DETAILS] vendorDocsEdit per vendor →", vendorDocsPerVendor.map(a => a.map(f => f.name)));
      console.log("[VIEW DETAILS] existingVendorDocsEdit →", normalizedDocs);

      setOpenEditLelangDialog(true);
      setIsEditing(false);
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Failed to open Lelang Details" });
    }
  };




  const getStatusClass = (status: string) => {
    switch (status) {
      case "Suspended":
        return "statusRed";
      case "Inactive":
        return "statusGray";
      case "Active":
        return "statusGreen";
      default:
        return "";
    }
  };

  const handleVendorChangeEdit = (index: number, vendorId: string) => {
    setLelangDataEdit((prev) => {
      const newVendorNames = [...prev.vendorNames];
      newVendorNames[index] = vendorId;

      // Ensure vendorProjectValue is array with same length
      const newVendorProjectValue = Array.isArray(prev.vendorProjectValue)
        ? [...prev.vendorProjectValue]
        : prev.vendorProjectValue
          ? [prev.vendorProjectValue]
          : new Array(prev.vendorNames.length).fill("");

      return {
        ...prev,
        vendorNames: newVendorNames,
        vendorProjectValue: newVendorProjectValue,
      };
    });
  };

  // Handle project value change
  const handleProjectValueChangeEdit = (index: number, value: string) => {
    setLelangDataEdit((prev) => {
      const newVendorProjectValue = Array.isArray(prev.vendorProjectValue)
        ? [...prev.vendorProjectValue]
        : prev.vendorProjectValue
          ? [prev.vendorProjectValue]
          : new Array(prev.vendorNames.length).fill("");

      newVendorProjectValue[index] = value;

      return {
        ...prev,
        vendorProjectValue: newVendorProjectValue,
      };
    });
  };

  // Add new vendor field
  const addVendorFieldEdit = () => {
    setLelangDataEdit((prev) => ({
      ...prev,
      vendorNames: [...prev.vendorNames, ""],
      vendorProjectValue: [
        ...(Array.isArray(prev.vendorProjectValue)
          ? prev.vendorProjectValue
          : [prev.vendorProjectValue || ""]),
        "",
      ],
    }));
  };

  // Remove vendor field
  const removeVendorFieldEdit = (index: number) => {
    setLelangDataEdit((prev) => ({
      ...prev,
      vendorNames: prev.vendorNames.filter((_, i) => i !== index),
      vendorProjectValue: (Array.isArray(prev.vendorProjectValue)
        ? prev.vendorProjectValue
        : [prev.vendorProjectValue || ""]
      ).filter((_, i) => i !== index),
    }));
  };

  const handleInputChangeEdit = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | { target: { name: string; value: any } }
  ) => {
    const { name, value } = event.target;

    setLelangDataEdit((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    console.log("Updated Lelang Data:", name, value); // Debugging
  };

  const handleEditFileUpload = (file) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setLelangDataEdit({ ...lelangDataEdit, file });
  };

  const handleCloseEdit = () => {
    setOpenEditLelangDialog(false);
    setIsEditing(false); // Reset mode edit saat ditutup
    setSelectedLelangId(null);
  };

  const [errorsEdit, setErrorsEdit] = useState({
    projectName: false,
    rabName: false,
    lelangDate: false,
    projectProcess: false,
    vendorNames: false,
    vendorProjectValue: false,
    lelangStatus: false,
  });

  const validateFormEdit = () => {
    const newErrors: any = {};

    const mandatoryFields = [
      "projectName",
      "rabName",
      "lelangDate",
      "projectProcess",
      "vendorNames",
      "vendorProjectValue",
      "lelangStatus",
    ];

    // Jika tipe inorganic → wajib isi lelang company
    // if (lelangDataEdit.lelangType === "inorganic") {
    //   mandatoryFields.push("company");
    // }

    // Validasi setiap field
    mandatoryFields.forEach((field) => {
      if (
        !lelangDataEdit[field] ||
        lelangDataEdit[field].toString().trim() === ""
      ) {
        newErrors[field] = true;
      }
    });

    setErrorsEdit(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFileUploadEdit = async (file) => {
    const validTypes = ["application/pdf"];
    const maxSize = 2 * 1024 * 1024; // 2MB
    if (!file) return;

    // Validate file type
    if (!isSpreadsheet(file) || file.size > MAX_UPLOAD_SIZE) {
      Swal.fire({
        icon: "error",
        title: "File harus CSV/XLS/XLSX ≤ 2MB",
      });
      return;
    }


    try {
      // If there's an existing proposal, delete it first
      if (lelangDataEdit.vendorProposalUrl && lelangDataEdit.id) {
        await deleteProposalFile(lelangDataEdit.id);
      }

      // Create preview URL for the new file
      const previewUrl = URL.createObjectURL(file);

      // Update state with new file
      setLelangDataEdit((prev) => ({
        ...prev,
        file,
        previewUrl,
        vendorProposalUrl: file.name,
      }));

      // Show success message
      // Swal.fire({
      //   icon: "success",
      //   title: "File uploaded successfully",
      //   showConfirmButton: false,
      //   timer: 1500,
      // });
    } catch (error) {
      console.error("Error handling file upload:", error);
      Swal.fire({
        icon: "error",
        title: "Upload failed",
        text: error.response?.data?.message || "Failed to update proposal file",
      });
    }
  };

  // Handle file deletion for edit mode
  const handleDeleteProposalEdit = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        if (lelangDataEdit.vendorProposalUrl && lelangDataEdit.id) {
          await deleteProposalFile(lelangDataEdit.id);
        }

        // Clear file from state
        setLelangDataEdit((prev) => ({
          ...prev,
          file: null,
          previewUrl: "",
          vendorProposalUrl: "",
        }));

        Swal.fire(
          "Deleted!",
          "Your proposal file has been deleted.",
          "success"
        );
      } catch (error) {
        console.error("Error deleting proposal:", error);
        Swal.fire({
          icon: "error",
          title: "Delete failed",
          text:
            error.response?.data?.message || "Failed to delete proposal file",
        });
      }
    }
  };

  const handleProjectChangeEdit = (event, newValue) => {
    if (newValue) {
      setLelangDataEdit((prev) => ({
        ...prev,
        projectId: newValue.projectReferenceId,
        projectListingId: newValue.id,
        projectName: newValue.projectName,
        clientName: newValue.source,
        projectType: newValue.projectType,
        constructionPhase: newValue.constructionPhase,
        projectAddress: newValue.projectAddress,
        latitude: newValue.latitude,
        longitude: newValue.longitude,
        lelangRegion: newValue.region,
        lelangCity: newValue.city,
        lelangDistrict: newValue.district,
        lelangStatus: newValue.lelangStatus ?? newValue.status ?? prev.lelangStatus,
      }));
    } else {
      // Reset all fields if no project selected
      setLelangDataEdit((prev) => ({
        ...prev,
        projectId: "",
        projectListingId: "",
        projectName: "",
        clientName: "",
        projectType: "",
        constructionPhase: "",
        projectAddress: "",
        latitude: "",
        longitude: "",
        lelangRegion: "",
        lelangCity: "",
        lelangDistrict: "",
      }));
    }
  };

  const handleSaveEdit = async () => {
    try {
      // Build valid vendor entries preserving order
      const entries = (lelangDataEdit.vendorNames || []).map((id, i) => ({
        id,
        value: Array.isArray(lelangDataEdit.vendorProjectValue) ? (lelangDataEdit.vendorProjectValue[i] || '') : (i === 0 ? (lelangDataEdit.vendorProjectValue as any) || '' : ''),
        status: vendorStatusesEdit[i] || '',
      })).filter(e => e.id && e.value !== '');

      const lelangStatusStr = entries.map(e => e.status).filter(Boolean).join(", ");
      const payload = {
        ...lelangDataEdit,
        vendorNames: entries.map(e => e.id),
        vendorProjectValue: entries.map(e => e.value),
        lelangStatus: lelangStatusStr,
      };
      await updateLelang(payload);

      // upload file proposal baru (jika ada)
      if (lelangDataEdit.file) {
        await uploadProposal(lelangDataEdit.id, lelangDataEdit.file, "biddingFile");
      }
      // Replace per-vendor semantics: loop strictly by vendor count
      const vendorCount = lelangDataEdit.vendorNames?.length || 0;
      const newKeysByIndex: (string | "")[] = Array.from({ length: vendorCount }, () => "");
      console.log('[SAVE-EDIT] vendorCount =', vendorCount);
      console.log('[SAVE-EDIT] vendorDocsEdit names per index →', (vendorDocsEdit || []).map(a => (a || []).map(f => f.name)));
      console.log('[SAVE-EDIT] existingVendorDocsEdit per index →', existingVendorDocsEdit);
      for (let i = 0; i < vendorCount; i++) {
        const existingKey = existingVendorDocsEdit[i] || "";
        const files = vendorDocsEdit[i] || [];
        if (files.length === 0) {
          // Dihapus
          newKeysByIndex[i] = "";
          continue;
        }
        const f = files[0]; // satu file per vendor
        if (f.name === existingKey) {
          // Tidak ada perubahan
          newKeysByIndex[i] = existingKey;
        } else {
          // Ganti file → upload baru
          const res = await uploadProposal(lelangDataEdit.id, f, "vendorDocument");
          if (res?.file) newKeysByIndex[i] = res.file;
        }
      }

      // Jangan kompres posisi: kirim array selaras vendor index, dengan string kosong untuk slot kosong
      const orderedDocs = newKeysByIndex;
      console.log('[SAVE-EDIT] orderedDocs to send →', orderedDocs);
      // Bandingkan dengan state existing (tanpa kompres)
      if (JSON.stringify(orderedDocs) !== JSON.stringify(existingVendorDocsEdit)) {
        await updateLelang({
          id: lelangDataEdit.id,
          vendorNames: lelangDataEdit.vendorNames,
          vendorProjectValue: lelangDataEdit.vendorProjectValue,
          vendorDocument: orderedDocs,
        });
      }

      Swal.fire({ icon: "success", title: "Perubahan disimpan" });
      setIsEditing(false);
      setOpenEditLelangDialog(false);
      reloadLelang();
    } catch (e) {
      console.error(e);
      Swal.fire({ icon: "error", title: "Gagal menyimpan perubahan" });
    }
  };

  // ======================================== end of function ========================================================
  // ============================================ start ui ===========================================================

  return isLoading ? (
    <LoadingOverlay />
  ) : (
    <Box sx={{ padding: 3 }}>
      {/* Header & Tabs */}
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}
      >
        <Typography variant="h6" fontWeight="bold">
          Lelang & Kontrak
        </Typography>
      </Box>

      {/* Toolbar */}
      <Box className="toolbar">
        {/* Left Controls */}
        <Box className="leftControls">
          <Typography>Show</Typography>
          <Select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }}
            size="small"
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>

          {/* Search Button & Input */}
          <Button
            variant="contained"
            startIcon={<Search />}
            onClick={() => setShowSearch((prev) => !prev)}
            className="searchButton"
          >
            Search
          </Button>
          {showSearch && (
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search"
              value={searchQuery}
              onChange={async (e) => {
                await setSearchQuery(e.target.value);
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
              autoFocus
              className="searchInput"
            />
          )}

          {/* Menampilkan Error */}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </Box>

        {/* Right Controls */}
        <Box className="rightControls">
          <Badge
            color="error"
            overlap="circular"
            badgeContent={selectedRows.length}
            invisible={selectedRows.length === 0}
            sx={{ mr: 1 }}
          >
            <Button
              startIcon={<Delete />}
              variant="text"
              onClick={() => handleDeleteLelang(true)}
              disabled={selectedRows.length === 0}
            >
              Delete
            </Button>
          </Badge>

          {/* Filter Button */}
          <Button
            startIcon={<FilterList />}
            variant="text"
            onClick={() => setOpenFilterDialog(true)}
          >
            Filters
          </Button>

          <Button
            startIcon={<Download />}
            variant="contained"
            className="exportButton"
            onClick={handleExport}
          >
            Export
          </Button>

          <Button
            startIcon={<Add />}
            variant="contained"
            className="addCategoryButton"
            onClick={handleOpenAddDialog} // Ganti dari setOpenAddEmployeeDialog
          >
            Add New Lelang
          </Button>
        </Box>
      </Box>

      <Box className="deleteContainer">
        <Typography variant="body2" className="detailsSubtitle">
          Details List Of Lelang
        </Typography>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} className="tableContainer">
        <Table className="table">
          <TableHead className="tableHead">
            <TableRow>
              <TableCell padding="checkbox" className="tableCell">
                {(() => {
                  const pageIds = displayedRows.map((r) => r.id);
                  const pageSelectedCount = pageIds.filter((id) => selectedRows.includes(id)).length;
                  const allOnPageSelected = pageIds.length > 0 && pageSelectedCount === pageIds.length;
                  const someOnPageSelected = pageSelectedCount > 0 && pageSelectedCount < pageIds.length;
                  return (
                    <Checkbox
                      indeterminate={someOnPageSelected}
                      checked={allOnPageSelected}
                      onChange={() => {
                        if (allOnPageSelected) {
                          // Unselect only current page
                          setSelectedRows(selectedRows.filter((id) => !pageIds.includes(id)));
                        } else {
                          // Select all on current page, keep previous selections from other pages
                          const merged = Array.from(new Set([...selectedRows, ...pageIds]));
                          setSelectedRows(merged);
                        }
                      }}
                    />
                  );
                })()}
              </TableCell>
              <TableCell className="tableCell" width="50px">
                <strong>No</strong>
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("projectName")}
                style={{ cursor: "pointer" }}
              >
                <strong>Project Name</strong>
                {sortConfig.orderBy === "projectName" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell
                className="tableCell"
                onClick={() => handleSort("rabValue")}
                style={{ cursor: "pointer" }}
              >
                <strong>Bid Ammount</strong>
                {sortConfig.orderBy === "rabValue" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("lelangDate")}
                style={{ cursor: "pointer" }}
              >
                <strong>lelang Date</strong>
                {sortConfig.orderBy === "lelangDate" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("clientName")}
                style={{ cursor: "pointer" }}
              >
                <strong>Source</strong>
                {sortConfig.orderBy === "clientName" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("projectType")}
                style={{ cursor: "pointer" }}
              >
                <strong>Type</strong>
                {sortConfig.orderBy === "projectType" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("constructionPhase")}
                style={{ cursor: "pointer" }}
              >
                <strong>Phase</strong>
                {sortConfig.orderBy === "constructionPhase" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("projectProcess")}
                style={{ cursor: "pointer" }}
              >
                <strong>Project Process</strong>
                {sortConfig.orderBy === "projectProcess" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("vendorNames")}
                style={{ cursor: "pointer" }}
              >
                <strong>Vendor Names</strong>
                {sortConfig.orderBy === "vendorNames" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("status")}
                style={{ cursor: "pointer" }}
              >
                <strong>Lelang Status</strong>
                {sortConfig.orderBy === "status" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("contract")}
                style={{ cursor: "pointer" }}
              >
                <strong>Contract Status</strong>
                {sortConfig.orderBy === "contract" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={9} align="center" style={{ color: "red" }}>
                  {error}
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, index) => (
                <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={(event) => {
                        event.stopPropagation();
                        handleSelectRow(row.id);
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  <TableCell>
                    <strong>
                      {(() => {
                        const project = projectOptions.find(
                          (project) => project.id === row.projectName
                        );
                        if (project) {
                          // Use actualProjectName if available, otherwise fallback to other options
                          return project.actualProjectName || project.projectName || project.projectReferenceId || "-";
                        }
                        return row.projectName || "-";
                      })()}
                    </strong>
                  </TableCell>

                  <TableCell>{new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    minimumFractionDigits: 0,
                  }).format(parseFloat(row.bidAmount))}
                  </TableCell>
                  {/* {row.rabValue}</TableCell> */}
                  <TableCell>{row.lelangDate}</TableCell>
                  <TableCell>{row.clientName}</TableCell>
                  <TableCell>{row.projectType}</TableCell>
                  <TableCell>{row.constructionPhase}</TableCell>
                  <TableCell>{row.projectProcess}</TableCell>
                  <TableCell>
                    {Array.isArray(row.vendorNames)
                      ? row.vendorNames
                        .map(
                          (id) =>
                            vendors.find((v) => v.vendorId === id)?.vendorName
                        )
                        .filter(Boolean)
                        .join(", ") || "-"
                      : vendors.find((v) => v.vendorId === row.vendorNames)
                        ?.vendorName || "-"}
                  </TableCell>
                  <TableCell>{row.lelangStatus}</TableCell>
                  <TableCell>{row.contractStatus}</TableCell>

                  <TableCell className="tableCell">
                    <IconButton onClick={() => handleOpenEditDialog(row)}>
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box
        className="paginationContainer"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "16px 0",
        }}
      >
        {/* Info jumlah data */}
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`Showing ${offset + 1} to ${Math.min(
            offset + rowsPerPage,
            totalItems
          )} of ${totalItems} entries`}
        </Typography>

        {/* Komponen Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => setCurrentPage(page)}
          className="pagination"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{ first: FirstPage, last: LastPage }}
            />
          )}
        />
      </Box>

      {/* ======================= Filter Dialog ============================= */}
      <Dialog
        open={openFilterDialog}
        onClose={() => setOpenFilterDialog(false)}
      >
        <DialogTitle>Advanced Search</DialogTitle>
        <DialogContent>
          {filters.map((filter, index) => {
            const usedFields = filters
              .map((f, i) => i !== index && f.field)
              .filter(Boolean);
            const availableOptions = availableFilters.filter(
              (opt) => !usedFields.includes(opt.value)
            );

            return (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                gap={1}
                mb={2}
              >
                <TextField
                  select
                  value={filter.field}
                  onChange={(e) =>
                    handleFilterChange(index, "field", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1, minWidth: 160 }}
                >
                  {availableOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                {/* Render input berdasarkan jenis field */}
                {(() => {
                  // Field dengan dropdown khusus
                  if (filter.field === "projectName") {
                    return (
                      <Autocomplete
                        options={projectOptions}
                        getOptionLabel={(option) => option.actualProjectName || option.projectName || ""}
                        value={
                          projectOptions.find(
                            (opt) => (opt.actualProjectName || opt.projectName) === filter.value
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          const newFilters = [...filters];
                          newFilters[index].value = newValue?.actualProjectName || newValue?.projectName || "";
                          setFilters(newFilters);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Project Name"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1, minWidth: 200 }}
                          />
                        )}
                      />
                    );
                  } else if (filter.field === "rabName") {
                    return (
                      <Autocomplete
                        loading={loadingRabs}
                        options={rabOptions}
                        getOptionLabel={(option) => option.rabName || ""}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        value={
                          rabOptions.find(
                            (opt) => opt.rabName === filter.value
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          const newFilters = [...filters];
                          newFilters[index].value = newValue?.rabName || "";
                          setFilters(newFilters);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="RAB Name"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1, minWidth: 200 }}
                            placeholder="Select RAB"
                          />
                        )}
                      />
                    );
                  } else if (filter.field === "vendorNames") {
                    return (
                      <Autocomplete
                        loading={loadingVendors}
                        options={vendors}
                        getOptionLabel={(option) => option.vendorName || ""}
                        isOptionEqualToValue={(option, value) =>
                          option.vendorId === value.vendorId
                        }
                        value={
                          vendors.find((v) => v.vendorName === filter.value) ||
                          null
                        }
                        onChange={(event, newValue) => {
                          const newFilters = [...filters];
                          newFilters[index].value = newValue?.vendorName || "";
                          setFilters(newFilters);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Vendor Name"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1, minWidth: 200 }}
                            placeholder="Select Vendor"
                          />
                        )}
                      />
                    );
                  }

                  // Field dengan input tanggal khusus
                  else if (filter.field === "lelangDate") {
                    return (
                      <TextField
                        type="date"
                        label="lelang Date"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    );
                  }

                  // Field dengan input number khusus
                  else if (filter.field === "bidAmmount") {
                    return (
                      <TextField
                        type="number"
                        label="Bid Amount"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    );
                  }

                  // Default text input untuk field lainnya
                  else {
                    return (
                      <TextField
                        label="Value"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    );
                  }
                })()}

                {index > 0 && (
                  <IconButton onClick={() => handleRemoveFilter(index)}>
                    <Remove />
                  </IconButton>
                )}
              </Box>
            );
          })}

          {filters.length < availableFilters.length && (
            <Button startIcon={<Add />} onClick={handleAddFilter}>
              Add Filter
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetFilters}>Reset Filter</Button>
          <Button onClick={handleCloseFilter}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Apply"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================== POPUP Add New Lelang =========================== */}
      <Dialog
        open={openAddLelangDialog}
        onClose={() => setOpenAddLelangDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Add New Lelang
          </Typography>
          <IconButton onClick={handleCloseAdd} color="error">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              gap: 3,
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Grid container spacing={2}>
              {/* Profile Picture & Lelang ID */}
              <Grid item xs={6} sm={6}>
                {/* Form Input Section */}
                <Box sx={{ flex: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    PROJECT LISTING
                  </Typography>
                  <Typography variant="caption" color="textSecondary" sx={{ mb: 1, display: 'block' }}>
                    * Pilih project untuk auto-complete data RAB, lelang date, project process, dan status
                  </Typography>
                  <Autocomplete
                    fullWidth
                    options={rapSearchOptions}
                    getOptionLabel={(option: any) => option?.project?.projectName || ""}
                    value={rapSearchOptions.find((opt: any) => opt?.project?.id === lelangDataAdd.projectListingId) || null}
                    onChange={async (event, rap: any) => {
                      if (!rap) {
                        setLelangDataAdd((prev) => ({ ...prev, projectListingId: "", projectName: "" }));
                        return;
                      }
                      const proj = rap.project || {};
                      const bid = rap.bidding || {};
                      const rab = rap.rab || {};
                      const loc = parseProjectLocation(bid.projectLocation || "");

                      setLelangDataAdd((prev) => ({
                        ...prev,
                        projectListingId: proj.id || "",
                        projectName: proj.projectName || "",
                        clientName: bid.clientName || proj.source || "",
                        projectId: bid.projectId || proj.projectReferenceId || "",
                        projectType: proj.projectType || bid.projectType || "",
                        constructionPhase: proj.constructionPhase || bid.constructionPhase || "",
                        projectAddress: proj.projectAddress || loc.address || "",
                        latitude: proj.latitude || loc.latitude || "",
                        longitude: proj.longitude || loc.longitude || "",
                        lelangRegion: proj.region || loc.region || "",
                        lelangCity: proj.city || loc.city || "",
                        lelangDistrict: proj.district || loc.district || "",
                        rabId: rab.id || bid.rabName || "",
                        rabName: rab.rabName || "",
                        rabValue: rab.totalPrice ? Number(rab.totalPrice) : (bid.rabValue ? Number(bid.rabValue) : 0),
                        startDate: proj.startDate || bid.startDate || "",
                        endDate: proj.endDate || bid.endDate || "",
                        projectProcess: bid.projectProcess || "",
                        vendorNames: Array.isArray(bid.vendorNames) ? bid.vendorNames : [],
                        vendorProjectValue: Array.isArray(bid.vendorProjectValue) ? bid.vendorProjectValue : [],
                        lelangStatus: bid.status || "",
                        salesProjectId: proj.salesProjectId || "",
                      }));

                      // Pastikan RAB options tampil dengan label yang benar
                      if (rab?.id) {
                        try {
                          const resp = await getRabDetail({ rabId: rab.id });
                          setRabDetails(Array.isArray(resp?.data) ? resp.data : []);
                          const name = rab.rabName || (Array.isArray(resp?.data) && resp.data[0]?.rabName) || "";
                          const total = rab.totalPrice || (Array.isArray(resp?.data) && resp.data[0]?.totalPrice) || 0;
                          setRabOptions(prev => (prev.some(r => r.id === rab.id) ? prev : [...prev, { id: rab.id, rabName: name, totalPrice: total, project: { id: proj.id, projectName: proj.projectName, projectReferenceId: proj.projectReferenceId, startDate: proj.startDate, endDate: proj.endDate } } as any]));
                        } catch (e) {
                          console.warn('[RAB-DETAILS] gagal load untuk RAB terpilih', e);
                          setRabDetails([]);
                        }
                      } else {
                        setRabDetails([]);
                      }

                      // Sinkron status vendor (satu status untuk semua vendor dari bidding)
                      const vendorCount = (Array.isArray(bid.vendorNames) ? bid.vendorNames.length : 0) || 1;
                      setVendorStatuses(Array.from({ length: vendorCount }, () => bid.status || ""));
                      setVendorDocs(Array.from({ length: vendorCount }, () => []));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Project Name"
                        placeholder="Select project"
                        fullWidth
                        error={!lelangDataAdd.projectListingId}
                        helperText={
                          !lelangDataAdd.projectListingId
                            ? "Mandatory Field"
                            : ""
                        }
                      />
                    )}
                  />
                  <TextField
                    fullWidth
                    label="Client Name"
                    margin="normal"
                    variant="outlined"
                    value={lelangDataAdd.clientName || ""}
                    sx={{ mb: 1 }}
                    name="clientName"
                    placeholder="Enter Client Name"
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Project ID / Refference"
                    margin="normal"
                    variant="outlined"
                    value={lelangDataAdd.projectId || ""}
                    sx={{ mb: 1 }}
                    name="projectId"
                    placeholder="Enter Project ID / Refference"
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Project Type"
                    margin="normal"
                    variant="outlined"
                    value={lelangDataAdd.projectType || ""}
                    sx={{ mb: 1 }}
                    name="projectType"
                    placeholder="Enter Project Type"
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Construction Phase"
                    margin="normal"
                    variant="outlined"
                    value={lelangDataAdd.constructionPhase || ""}
                    sx={{ mb: 1 }}
                    name="constructionPhase"
                    placeholder="Enter Project Type"
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={{ mt: 51 }}
                  >
                    RAB
                  </Typography>
                  <Autocomplete
                    fullWidth
                    options={lelangDataAdd.rabId ? [{ id: lelangDataAdd.rabId, rabName: lelangDataAdd.rabName }] : [] as any}
                    getOptionLabel={(o) => o.rabName || ''}
                    isOptionEqualToValue={(o, v) => o.id === v.id}
                    value={lelangDataAdd.rabId ? ({ id: lelangDataAdd.rabId, rabName: lelangDataAdd.rabName } as any) : null}
                    disabled
                    onChange={(_, v) => {
                      setLelangDataAdd(prev => ({
                        ...prev,
                        rabId: (v as any)?.id || '',
                        rabName: (v as any)?.rabName || '',
                      }));
                      if ((v as any)?.id) {
                        getRabDetail({ rabId: (v as any).id })
                          .then(resp => setRabDetails(Array.isArray(resp?.data) ? resp.data : []))
                          .catch(e => { console.warn('[RAB-DETAILS] failed to load on change', e); setRabDetails([]); });
                      } else {
                        setRabDetails([]);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="RAB Name"
                        placeholder="Select RAB"
                        error={!lelangDataAdd.rabId}
                        helperText={!lelangDataAdd.rabId ? 'Mandatory Field' : ''}
                      />
                    )}
                  />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Lelang Date"
                      format="YYYY-MM-DD"
                      value={
                        lelangDataAdd.lelangDate
                          ? dayjs(lelangDataAdd.lelangDate)
                          : null
                      }
                      onChange={(newValue) =>
                        handleInputChangeAdd({
                          target: {
                            name: "lelangDate",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: { mt: 25.05, mb: 1 },
                          name: "lelangDate",
                          error: !lelangDataAdd.lelangDate,
                          helperText: !lelangDataAdd.lelangDate
                            ? "Mandatory Field"
                            : "",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <Typography variant="subtitle1" fontWeight="bold">
                    File Lelang
                  </Typography>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      gap: 3,
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "2px dashed #aaa",
                      padding: 4,
                      borderRadius: "12px",
                      backgroundColor: "#fafafa",
                      textAlign: "center",
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onClick={() => lelangFileInputRef.current?.click()}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                        handleLelangFileUpload(e.dataTransfer.files[0]);
                      }
                    }}
                  >
                    {lelangFilePreview ? (
                      <>
                        <GridOn fontSize="large" color="primary" />
                        <Typography variant="body2" mt={1}>
                          {lelangDataAdd.lelangFile?.name || "Uploaded PDF"}
                        </Typography>
                        <IconButton
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            backgroundColor: "rgba(255,255,255,0.7)",
                            "&:hover": {
                              backgroundColor: "rgba(255,255,255,0.9)",
                            },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setLelangFilePreview("");
                            setLelangDataAdd((prev) => ({ ...prev, lelangFile: null }));
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </>
                    ) : (
                      <>
                        <GridOn fontSize="large" color="action" />
                        <Typography variant="body2" color="textSecondary" mt={1}>
                          Drag & drop or click to upload File Lelang (CSV/XLS/XLSX/PDF/DOC/DOCX)
                        </Typography>
                        <Typography variant="caption" mt={1}>
                          Max size: 2MB
                        </Typography>
                      </>
                    )}
                    <input
                      hidden
                      type="file"
                      ref={lelangFileInputRef}
                      accept={SPREADSHEET_ACCEPT} // <-- ganti dari .pdf
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          handleLelangFileUpload(e.target.files[0]);
                        }
                      }}
                    />

                  </Box>
                  <TextField
                    select
                    fullWidth
                    label="Contract Status"
                    name="contractStatus"
                    placeholder="Select Contract Status"
                    sx={{ mt: 8, mb: 1 }}
                    value={lelangDataAdd.contractStatus}
                    onChange={handleInputChangeAdd}
                    error={!lelangDataAdd.contractStatus}
                    helperText={!lelangDataAdd.contractStatus ? "Mandatory Field" : ""}
                  >
                    <MenuItem value="" disabled>
                      Select item
                    </MenuItem>
                    <MenuItem value="Inprogress">Inprogress</MenuItem>
                    <MenuItem value="Partial Complete">Partial Complete</MenuItem>
                    <MenuItem value="Completed">Completed</MenuItem>
                  </TextField>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                {/* Map Placeholder */}
                <Typography variant="subtitle1" fontWeight="bold">
                  PROJECT ADDRESS
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Enter Project Address"
                  sx={{ textAlign: "left", mt: 1 }}
                  value={lelangDataAdd.projectAddress}
                  name="projectAddress"
                  onChange={handleInputChangeAdd}
                  disabled
                />
                <Box
                  sx={{
                    width: "100%",
                    height: "auto",
                    bgcolor: "inherit",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    my: 2,
                  }}
                >
                  <MapPinLocation
                    latitude={lelangDataAdd.latitude}
                    longitude={lelangDataAdd.longitude}
                    onSelect={({ lat, lng }) => {
                      // if (isEditing) {
                      setLelangDataAdd({
                        ...lelangDataAdd,
                        latitude: lat.toString(),
                        longitude: lng.toString(),
                      });
                      // }
                      // else {
                      //   setOfficeData({ ...officeData, latitude: lat.toString(), longitude: lng.toString() });
                      // }
                    }}
                  />
                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth
                    label="Input Latitude"
                    name="latitude"
                    placeholder="Enter latitude"
                    value={lelangDataAdd.latitude}
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Input Longitude"
                    name="longitude"
                    placeholder="Enter longitude"
                    value={lelangDataAdd.longitude}
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                </Box>
                <TextField
                  fullWidth
                  label="Region"
                  margin="normal"
                  variant="outlined"
                  placeholder="Enter Lelang Country"
                  value={lelangDataAdd.lelangRegion}
                  sx={{ mb: 1 }}
                  name="lelangRegion"
                  onChange={handleInputChangeAdd}
                  disabled
                />
                <TextField
                  fullWidth
                  label="City"
                  name="lelangCity"
                  placeholder="Enter Lelang City"
                  sx={{ mb: 1 }}
                  value={lelangDataAdd.lelangCity}
                  onChange={handleInputChangeAdd}
                  disabled
                />
                <TextField
                  fullWidth
                  label="District"
                  name="lelangDistrict"
                  placeholder="Enter Lelang District"
                  sx={{ mb: 1 }}
                  value={lelangDataAdd.lelangDistrict}
                  onChange={handleInputChangeAdd}
                  disabled
                />
                <TextField
                  fullWidth
                  label="Bid Amount"
                  name="rabValue"
                  placeholder="Bid amount"
                  sx={{ mt: 16, mb: 1 }}
                  value={lelangDataAdd.rabValue || 0}
                  onChange={handleInputChangeAdd}
                  InputProps={{
                    readOnly: true, // Make read-only if it should only come from RAB selection
                    startAdornment: (
                      <InputAdornment position="start">Rp</InputAdornment>
                    ),
                  }}
                  disabled={!!lelangDataAdd.projectListingId} // Disable if project is selected
                />
                <TextField
                  fullWidth
                  label="Start Date"
                  name="startDate"
                  placeholder="Start date"
                  sx={{ mb: 1 }}
                  value={lelangDataAdd.startDate || ""}
                  onChange={handleInputChangeAdd}
                  disabled={!!lelangDataAdd.projectListingId} // Disable if project is selected
                />
                <TextField
                  fullWidth
                  label="End Date"
                  name="endDate"
                  placeholder="End date"
                  sx={{ mb: 1 }}
                  value={lelangDataAdd.endDate || ""}
                  onChange={handleInputChangeAdd}
                  disabled={!!lelangDataAdd.projectListingId} // Disable if project is selected
                />
                <TextField
                  select
                  fullWidth
                  label="Project Process"
                  name="projectProcess"
                  placeholder="Enter Project Process"
                  sx={{ mt: 8, mb: 1 }}
                  value={lelangDataAdd.projectProcess}
                  onChange={handleInputChangeAdd}
                  error={!lelangDataAdd.projectProcess}
                  helperText={
                    !lelangDataAdd.projectProcess ? "Mandatory Field" : ""
                  }
                // Project Process tetap editable
                >
                  <MenuItem value="" disabled>
                    Select item
                  </MenuItem>
                  <MenuItem value="Swadaya">Swadaya</MenuItem>
                  <MenuItem value="Partial">Partial</MenuItem>
                  <MenuItem value="Full Vendor">Full Vendor</MenuItem>
                </TextField>
                {/* Vendor Names Section */}
                {lelangDataAdd.vendorNames.map((vendorId, index) => {
                  const vendor = vendors.find((v) => v.vendorId === vendorId);
                  const projectValue = Array.isArray(lelangDataAdd.vendorProjectValue)
                    ? lelangDataAdd.vendorProjectValue[index] || ""
                    : index === 0 ? lelangDataAdd.vendorProjectValue || "" : "";

                  return (
                    <Box key={index} sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2, mb: 2 }}>
                      <Grid container spacing={1} alignItems="center">
                        {/* row: vendor & value + remove */}
                        <Grid item xs={6}>
                          <Typography variant="subtitle2" fontWeight="bold">Vendor Names</Typography>
                          <Autocomplete
                            options={vendors}
                            getOptionLabel={(o) => o.vendorName || ""}
                            isOptionEqualToValue={(o, v) => o.vendorId === v.vendorId}
                            value={vendor || null}
                            onChange={(_, v) => handleVendorChangeAdd(index, v?.vendorId || "")}
                            renderInput={(params) => (
                              <TextField {...params} placeholder="Select Vendor" size="small"
                                error={!vendorId && index === 0}
                                helperText={!vendorId && index === 0 ? "Please select at least one vendor" : ""}
                              />
                            )}
                            disabled={loadingVendors}
                          />
                        </Grid>

                        <Grid item xs={4}>
                          <Typography variant="subtitle2" fontWeight="bold">Vendor Values</Typography>
                          <TextField
                            fullWidth size="small" placeholder="Enter Value"
                            value={projectValue}
                            onChange={(e) => handleProjectValueChangeAdd(index, e.target.value)}
                            error={!projectValue && index === 0}
                            helperText={!projectValue && index === 0 ? "Please enter project value" : ""}
                          />
                        </Grid>

                        <Grid item xs={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
                          {index > 0 && (
                            <IconButton onClick={() => removeVendorField(index)} color="error">
                              <DeleteOutline />
                            </IconButton>
                          )}
                        </Grid>

                        {/* row: lelang status */}
                        <Grid item xs={12}>
                          <TextField
                            select fullWidth size="small" label="Lelang Status"
                            value={vendorStatuses[index] || ""}
                            onChange={(e) => handleVendorStatusChange(index, e.target.value)}
                            error={!vendorStatuses[index]}
                            helperText={!vendorStatuses[index] ? "Mandatory Field" : ""}
                          >
                            <MenuItem value="" disabled>Select item</MenuItem>
                            <MenuItem value="Submit">Submit</MenuItem>
                            <MenuItem value="Review">Review</MenuItem>
                            <MenuItem value="Shortlisted">Shortlisted</MenuItem>
                            <MenuItem value="Rejected">Rejected</MenuItem>
                            <MenuItem value="Awarded">Awarded</MenuItem>
                          </TextField>
                        </Grid>

                        {/* row: vendor docs dropzone per vendor */}
                        <Grid item xs={12}>
                          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                            Vendor Documents
                          </Typography>
                          <Box
                            sx={{
                              border: "2px dashed #aaa", borderRadius: 2, p: 4, textAlign: "center",
                              cursor: "pointer", bgcolor: "#fafafa"
                            }}
                            onClick={() => document.getElementById(`vendor-docs-input-${index}`)?.click()}
                            onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                            onDrop={(e) => {
                              e.preventDefault(); e.stopPropagation();
                              if (e.dataTransfer.files?.length) {
                                handleVendorDocsUploadByIndex(index, e.dataTransfer.files);
                              }
                            }}
                          >
                            <GridOn sx={{ fontSize: 40, mb: 1 }} />
                            <Typography variant="body2">
                              Drag & drop or click to upload Vendor Documents (CSV/XLS/XLSX/PDF/DOC/DOCX)
                            </Typography>
                            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                              Max size: 2MB
                            </Typography>
                          </Box>

                          <input
                            id={`vendor-docs-input-${index}`}
                            type="file"
                            hidden
                            multiple
                            accept={SPREADSHEET_ACCEPT} // <-- ganti dari .pdf
                            onChange={(e) => e.target.files && handleVendorDocsUploadByIndex(index, e.target.files)}
                          />

                          {(vendorDocs[index] || []).map((f, fi) => (
                            <Box key={fi} sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                              <GridOn fontSize="small" />

                              <Typography variant="body2" sx={{ flex: 1, wordBreak: "break-all" }}>
                                {buildVendorDocDisplayName(f.name, index, "add")}
                              </Typography>
                              <IconButton size="small" onClick={() => {
                                // pakai remover yang sudah ada
                                const next = [...vendorDocs];
                                next[index] = next[index].filter((_, i) => i !== fi);
                                setVendorDocs(next);
                                setLelangDataAdd(prev => ({
                                  ...prev,
                                  vendorDocument: (Array.isArray(prev.vendorDocument) ? prev.vendorDocument : [])
                                    .filter(n => n !== f.name)
                                }));
                              }}>
                                <Close />
                              </IconButton>
                            </Box>
                          ))}
                        </Grid>
                      </Grid>
                    </Box>
                  );
                })}

                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                  <Button variant="text" startIcon={<Add />} onClick={addVendorField}>
                    Add other vendors
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        {/* Buttons: Save & Close */}
        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
        >
          <Button variant="outlined" color="error" onClick={handleCloseAdd}>
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleSaveAdd}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================================ POPUP Edit Lelang ======================================*/}
      <Dialog
        open={openEditLelangDialog}
        onClose={() => setOpenEditLelangDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle>
          {isEditing ? "Edit Lelang" : "Lelang Details"}
          <IconButton
            onClick={handleCloseEdit}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              gap: 3,
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Grid container spacing={2}>
              {/* Profile Picture & Lelang ID */}
              <Grid item xs={6} sm={6}>
                {/* Form Input Section */}
                <Box sx={{ flex: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    PROJECT LISTING
                  </Typography>
                  <Autocomplete
                    fullWidth
                    options={projectOptions}
                    getOptionLabel={(opt) => opt.actualProjectName || opt.projectName || opt.projectReferenceId || ""}
                    isOptionEqualToValue={(opt, val) => opt.id === val.id}
                    // gunakan value nyata dari options, kalau belum ada options pakai "dummy" biar label tetap tampil
                    value={
                      projectOptions.find(opt => opt.id === lelangDataEdit.projectListingId) ||
                      (lelangDataEdit.projectListingId
                        ? { id: lelangDataEdit.projectListingId, projectName: lelangDataEdit.projectName || "" } as any
                        : null)
                    }
                    onChange={(_, v) => {
                      if (!isEditing) return;
                      setLelangDataEdit(prev => ({
                        ...prev,
                        projectListingId: v?.id || "",
                        projectName: v?.projectName || v?.actualProjectName || prev.projectName,
                      }));
                      // kalau mau autofill RAB/dates, panggil handler-mu di sini
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Project Name" placeholder="Select project" fullWidth disabled={!isEditing} />
                    )}
                    disabled={!isEditing}
                  />
                  <TextField
                    fullWidth
                    label="Client Name"
                    margin="normal"
                    variant="outlined"
                    value={lelangDataEdit.clientName || ""}
                    sx={{ mb: 1 }}
                    name="clientName"
                    placeholder="Enter Client Name"
                    onChange={handleInputChangeEdit}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Project ID / Refference"
                    margin="normal"
                    variant="outlined"
                    value={lelangDataEdit.projectId || ""}
                    sx={{ mb: 1 }}
                    name="projectId"
                    placeholder="Enter Project ID / Refference"
                    onChange={handleInputChangeEdit}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Project Type"
                    margin="normal"
                    variant="outlined"
                    value={lelangDataEdit.projectType || ""}
                    sx={{ mb: 1 }}
                    name="projectType"
                    placeholder="Enter Project Type"
                    onChange={handleInputChangeEdit}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Construction Phase"
                    margin="normal"
                    variant="outlined"
                    value={lelangDataEdit.constructionPhase || ""}
                    sx={{ mb: 1 }}
                    name="constructionPhase"
                    placeholder="Enter Construction Phase"
                    onChange={handleInputChangeEdit}
                    disabled
                  />
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={{ mt: 51 }}
                  >
                    RAB
                  </Typography>
                  <Autocomplete
                    options={rabOptions}
                    getOptionLabel={(option) => option.rabName || ""}
                    value={rabOptions.find((r) => r.id === lelangDataEdit.rabId) || null}
                    onChange={(e, value) =>
                      setLelangDataEdit({ ...lelangDataEdit, rabId: value?.id || "", rabName: value?.rabName || "" })
                    }
                    renderInput={(params) => <TextField {...params} label="RAB Name" />}
                    disabled // <— bikin non-editable
                  />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="lelang Date"
                      format="YYYY-MM-DD"
                      value={
                        lelangDataEdit.lelangDate
                          ? dayjs(lelangDataEdit.lelangDate)
                          : null
                      }
                      onChange={(newValue) =>
                        handleInputChangeEdit({
                          target: {
                            name: "lelangDate",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        })
                      }
                      disabled={!isEditing}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: { mt: 26.05, mb: 1 },
                          name: "lelangDate",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      gap: 3,
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      border:
                        lelangDataEdit.previewUrl ||
                          lelangDataEdit.file ||
                          lelangDataEdit.vendorProposalUrl
                          ? "2px solid #aaa"
                          : "2px dashed #aaa",
                      padding: 4,
                      borderRadius: "12px",
                      backgroundColor: "#fafafa",
                      textAlign: "center",
                      cursor: isEditing ? "pointer" : "default",
                      position: "relative",
                      opacity: isEditing ? 1 : 0.7,
                    }}
                    onClick={() => isEditing && editFileInputRef.current?.click()}
                  >
                    {lelangDataEdit.previewUrl ||
                      lelangDataEdit.file ||
                      lelangDataEdit.vendorProposalUrl ? (
                      <>
                        <GridOn fontSize="large" color={isEditing ? "primary" : "disabled"} />

                        <Typography variant="body2" mt={1}>
                          {(() => {

                            const selectedProject =
                              projectOptions.find((opt) => opt.id === lelangDataEdit.projectListingId) ||
                              projectOptions.find((opt) => opt.projectName === lelangDataEdit.projectName);

                            // Exactly the same format as your working component
                            const getExt = (name?: string) => (name?.includes(".") ? name.split(".").pop()!.toLowerCase() : "xlsx");

                            const ext = getExt(lelangDataEdit.vendorProposalUrl);
                            const projName = selectedProject?.actualProjectName || selectedProject?.projectName || lelangDataEdit.projectName || "Unknown Project";
                            return `File Lelang_${projName
                              .replace(/\s+/g, "_")
                              .replace(/[^a-zA-Z0-9_]/g, "")
                              .substring(0, 50)}.${ext}`;
                          })()}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          Original ID: {lelangDataEdit.vendorProposalUrl}
                        </Typography>

                        {isEditing && (
                          <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (lelangDataEdit.vendorProposalUrl) {
                                  handleDownload(lelangDataEdit.vendorProposalUrl);
                                }
                              }}
                            >
                              DOWNLOAD
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              color="error"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteProposalEdit();
                              }}
                            >
                              DELETE
                            </Button>
                          </Box>
                        )}
                      </>
                    ) : (
                      <>
                        <GridOn fontSize="large"
                          color={isEditing ? "action" : "disabled"}
                        />
                        <Typography variant="body2" mt={1}>
                          {isEditing ? "Drag & drop or click to upload proposal (CSV/XLS/XLSX)" : "No proposal file uploaded"}
                        </Typography>
                      </>
                    )}

                    {isEditing && (
                      <input
                        hidden
                        type="file"
                        ref={editFileInputRef}
                        accept={SPREADSHEET_ACCEPT}
                        onChange={(e) => {
                          if (e.target.files && e.target.files[0]) {
                            handleFileUploadEdit(e.target.files[0]);
                          }
                        }}
                      />
                    )}
                  </Box>
                  <TextField
                    select
                    fullWidth
                    label="Contract Status"
                    name="contractStatus"
                    placeholder="Select Contract Status"
                    sx={{ mt: 2, mb: 1 }}
                    value={lelangDataEdit.contractStatus || ""}
                    onChange={handleInputChangeEdit}
                    disabled={!isEditing}
                  >
                    <MenuItem value="" disabled>
                      Select item
                    </MenuItem>
                    <MenuItem value="Inprogress">Inprogress</MenuItem>
                    <MenuItem value="Partial Complete">Partial Complete</MenuItem>
                    <MenuItem value="Completed">Completed</MenuItem>
                  </TextField>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                {/* Map Placeholder */}
                <Typography variant="subtitle1" fontWeight="bold">
                  PROJECT ADDRESS
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Enter Project Address"
                  sx={{ textAlign: "left", mt: 1 }}
                  value={lelangDataEdit.projectAddress || ""}
                  name="projectAddress"
                  onChange={handleInputChangeEdit}
                  disabled
                />

                <Box
                  sx={{
                    width: "100%",
                    height: "auto",
                    bgcolor: "inherit",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    my: 2,
                  }}
                >
                  <MapPinLocation
                    latitude={lelangDataEdit.latitude}
                    longitude={lelangDataEdit.longitude}
                    onSelect={({ lat, lng }) => {
                      if (isEditing) {
                        setLelangDataEdit((prev) => ({
                          ...prev,
                          latitude: lat.toString(),
                          longitude: lng.toString(),
                        }));
                      }
                    }}
                    disabled
                  />
                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth
                    label="Input Latitude"
                    name="latitude"
                    placeholder="Enter latitude"
                    value={lelangDataEdit.latitude || ""}
                    onChange={handleInputChangeEdit}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Input Longitude"
                    name="longitude"
                    placeholder="Enter longitude"
                    value={lelangDataEdit.longitude || ""}
                    onChange={handleInputChangeEdit}
                    disabled
                  />
                </Box>

                <TextField
                  fullWidth
                  label="Country"
                  margin="normal"
                  variant="outlined"
                  placeholder="Enter Lelang Region"
                  value={lelangDataEdit.lelangRegion || ""}
                  sx={{ mb: 1 }}
                  name="lelangRegion"
                  onChange={handleInputChangeEdit}
                  disabled
                />
                <TextField
                  fullWidth
                  label="City"
                  name="lelangCity"
                  placeholder="Enter Lelang City"
                  sx={{ mb: 1 }}
                  value={lelangDataEdit.lelangCity || ""}
                  onChange={handleInputChangeEdit}
                  disabled
                />
                <TextField
                  fullWidth
                  label="District"
                  name="lelangDistrict"
                  placeholder="Enter Lelang District"
                  sx={{ mb: 1 }}
                  value={lelangDataEdit.lelangDistrict || ""}
                  onChange={handleInputChangeEdit}
                  disabled
                />
                <TextField
                  fullWidth
                  label="Bid Amount"
                  name="rabValue"
                  placeholder="Bid amount"
                  sx={{ mt: 13, mb: 1 }}
                  value={lelangDataEdit.rabValue || 0}
                  onChange={handleInputChangeEdit}
                  InputProps={{
                    readOnly: true, // Make read-only if it should only come from RAB selection
                    startAdornment: (
                      <InputAdornment position="start">Rp</InputAdornment>
                    ),
                  }}
                  disabled
                />
                <TextField
                  fullWidth
                  label="Start Date"
                  name="startDate"
                  placeholder="Start date"
                  sx={{ mb: 1 }}
                  value={lelangDataEdit.startDate || ""}
                  onChange={handleInputChangeEdit}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                />
                <TextField
                  fullWidth
                  label="End Date"
                  name="endDate"
                  placeholder="End date"
                  sx={{ mb: 1 }}
                  value={lelangDataEdit.endDate || ""}
                  onChange={handleInputChangeEdit}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                />
                <TextField
                  select
                  fullWidth
                  label="Project Process"
                  name="projectProcess"
                  placeholder="Enter Project Process"
                  sx={{ mt: 9.3, mb: 1 }}
                  value={lelangDataEdit.projectProcess}
                  onChange={handleInputChangeEdit}
                  error={!lelangDataEdit.projectProcess}
                  helperText={
                    !lelangDataEdit.projectProcess ? "Mandatory Field" : ""
                  }
                  disabled={!isEditing}
                >
                  <MenuItem value="" disabled>
                    Select item
                  </MenuItem>
                  <MenuItem value="Swadaya">Swadaya</MenuItem>
                  <MenuItem value="Partial">Partial</MenuItem>
                  <MenuItem value="Full Vendor">Full Vendor</MenuItem>
                </TextField>

                {/* === Vendors grouped (Edit) === */}
                {(lelangDataEdit.vendorNames || [""]).map((vendorId, index) => {
                  const vendor = vendors.find(v => v.vendorId === vendorId);
                  const value = (lelangDataEdit.vendorProjectValue || [])[index] || "";

                  return (
                    <Box key={index} sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2, mb: 2 }}>
                      <Grid container spacing={1} alignItems="center">
                        {/* Vendor Name */}
                        <Grid item xs={6}>
                          <Typography variant="subtitle2" fontWeight="bold">Vendor Names</Typography>
                          <Autocomplete
                            options={vendors}
                            getOptionLabel={(o) => o.vendorName || ""}
                            value={vendor || null}
                            onChange={(_, v) => {
                              if (!isEditing) return;
                              setLelangDataEdit(prev => {
                                const names = [...(prev.vendorNames || [])];
                                names[index] = v?.vendorId || "";
                                return { ...prev, vendorNames: names };
                              });
                            }}
                            renderInput={(p) => <TextField {...p} placeholder="Select Vendor" size="small" disabled={!isEditing} />}
                            disabled={!isEditing}
                          />
                        </Grid>

                        {/* Vendor Value */}
                        <Grid item xs={4}>
                          <Typography variant="subtitle2" fontWeight="bold">Vendor Values</Typography>
                          <TextField
                            fullWidth size="small" placeholder="Enter Value"
                            value={value}
                            onChange={(e) => {
                              if (!isEditing) return;
                              setLelangDataEdit(prev => {
                                const vals = [...(prev.vendorProjectValue || [])];
                                vals[index] = e.target.value;
                                return { ...prev, vendorProjectValue: vals };
                              });
                            }}
                            InputProps={{ startAdornment: <InputAdornment position="start">Rp</InputAdornment> }}
                            disabled={!isEditing}
                          />
                        </Grid>

                        {/* remove row */}
                        <Grid item xs={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
                          {isEditing && index > 0 && (
                            <IconButton onClick={() => {
                              setLelangDataEdit(prev => ({
                                ...prev,
                                vendorNames: (prev.vendorNames || []).filter((_, i) => i !== index),
                                vendorProjectValue: (prev.vendorProjectValue || []).filter((_, i) => i !== index),
                              }));
                              setVendorStatusesEdit(prev => prev.filter((_, i) => i !== index));
                              setVendorDocsEdit(prev => prev.filter((_, i) => i !== index));
                            }} color="error">
                              <DeleteOutline />
                            </IconButton>
                          )}
                        </Grid>

                        {/* Lelang Status per vendor */}
                        <Grid item xs={12}>
                          <TextField
                            select fullWidth size="small" label="Lelang Status"
                            value={vendorStatusesEdit[index] || ""}
                            onChange={(e) => isEditing && setVendorStatusesEdit(prev => {
                              const next = [...prev]; next[index] = e.target.value; return next;
                            })}
                            disabled={!isEditing}
                          >
                            <MenuItem value="" disabled>Select item</MenuItem>
                            <MenuItem value="Submit">Submit</MenuItem>
                            <MenuItem value="Review">Review</MenuItem>
                            <MenuItem value="Shortlisted">Shortlisted</MenuItem>
                            <MenuItem value="Rejected">Rejected</MenuItem>
                            <MenuItem value="Awarded">Awarded</MenuItem>
                          </TextField>
                        </Grid>

                        {/* Vendor Documents per vendor (CSV/XLS/XLSX) */}
                        <Grid item xs={12}>
                          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>Vendor Documents</Typography>

                          <Box
                            sx={{
                              border: "2px dashed #aaa", borderRadius: 2, p: 2, textAlign: "left",
                              cursor: isEditing ? "pointer" : "default", bgcolor: "#fafafa"
                            }}
                            onClick={() => isEditing && document.getElementById(`vendor-docs-edit-${index}`)?.click()}
                            onDragOver={(e) => { if (isEditing) { e.preventDefault(); e.stopPropagation(); } }}
                            onDrop={(e) => {
                              if (!isEditing) return;
                              e.preventDefault(); e.stopPropagation();
                              const picked = Array.from(e.dataTransfer.files)
                                .filter(f => isSpreadsheet(f) && f.size <= 2 * 1024 * 1024);
                              console.log("[VENDOR DOCS][Drop] picked files →", picked);

                              if (!picked.length) return;
                              setVendorDocsEdit(prev => {
                                const next = [...prev];
                                // Replace: only keep first file for this vendor slot
                                next[index] = [picked[0]];
                                console.log("[VENDOR DOCS][Drop] after setVendorDocsEdit →", next);
                                return next;
                              });
                              // Clear existing mapping to mark as changed
                              setExistingVendorDocsEdit(prev => {
                                const n = [...prev];
                                n[index] = '';
                                return n;
                              });
                            }}
                          >
                            {((vendorDocsEdit[index] || []).length > 0) ? (
                              (vendorDocsEdit[index] || []).map((f, fi) => (
                                <Box key={fi} sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5 }}>
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <GridOn fontSize="small" />
                                    <Typography variant="body2" sx={{ flex: 1, wordBreak: "break-all" }}>
                                      {buildVendorDocDisplayName(f.name, index, "edit")}
                                    </Typography>
                                    {isEditing && (
      <Button size="small" variant="outlined" onClick={(e) => { e.stopPropagation(); handleDownload(f.name, index); }}>
                                        DOWNLOAD
                                      </Button>
                                    )}
                                    {isEditing && (
                                      <IconButton size="small" onClick={(e) => {
                                        e.stopPropagation();
                                        setVendorDocsEdit(prev => {
                                          const next = [...prev]; next[index] = next[index].filter((_, i) => i !== fi); return next;
                                        });
                                      }}>
                                        <Close fontSize="small" />
                                      </IconButton>
                                    )}
                                  </Box>
                                  <Typography variant="caption" color="textSecondary">
                                    Original ID: {f.name}
                                  </Typography>
                                </Box>
                              ))
                            ) : (
                              <Box sx={{ textAlign: "center", py: 2 }}>
                                <GridOn sx={{ fontSize: 40, mb: 1 }} />
                                <Typography variant="body2">
                                  {isEditing ? "Drag & drop atau klik untuk upload Vendor Documents (CSV/XLS/XLSX/PDF/DOC/DOCX)" : "No documents"}
                                </Typography>
                                {isEditing && (
                                  <Typography variant="caption" display="block" sx={{ mt: 1 }}>Max size: 2MB</Typography>
                                )}
                              </Box>
                            )}
                          </Box>

                          <input
                            id={`vendor-docs-edit-${index}`} type="file" hidden multiple
                            accept=".csv,.xls,.xlsx,.pdf,.doc,.docx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            onChange={(e) => {
                              if (!isEditing || !e.target.files) return;
                              const picked = Array.from(e.target.files)
                                .filter(f => isSpreadsheet(f) && f.size <= 2 * 1024 * 1024);
                              console.log("[VENDOR DOCS][Change] picked files →", picked);

                              setVendorDocsEdit(prev => {
                                const next = [...prev];
                                // Replace semantics: keep only 1 file per vendor slot
                                next[index] = picked.length ? [picked[0]] : [];
                                console.log("[VENDOR DOCS][Change] after setVendorDocsEdit →", next);

                                return next;
                              });
                              // Clear existing mapping to avoid treating as unchanged
                              setExistingVendorDocsEdit(prev => {
                                const n = [...prev];
                                n[index] = '';
                                return n;
                              });
                            }}
                          />

                          {/* List di dalam kotak; tidak perlu render ulang di luar kotak */}


                        </Grid>
                      </Grid>
                    </Box>
                  );
                })}

                {isEditing && (
                  <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                    <Button variant="text" startIcon={<Add />} onClick={() => {
                      setLelangDataEdit(prev => ({
                        ...prev,
                        vendorNames: [...(prev.vendorNames || []), ""],
                        vendorProjectValue: [...(prev.vendorProjectValue || []), ""],
                      }));
                      setVendorStatusesEdit(prev => [...prev, ""]);
                      setVendorDocsEdit(prev => [...prev, []]);
                    }}>
                      Add other vendors
                    </Button>
                  </Box>
                )}

              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        {/* Buttons: Save & Close */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          {!isEditing ? (
            // Tombol Edit Muncul di Awal
            <Button
              onClick={() => setIsEditing(true)}
              variant="contained"
              color="primary"
              sx={{ width: 120 }}
            >
              EDIT
            </Button>
          ) : (
            // Tombol Save & Cancel Muncul Saat Edit
            <>
              <Button
                onClick={() => setIsEditing(false)}
                variant="outlined"
                color="error"
                sx={{ width: 120 }}
              >
                CANCEL
              </Button>
              <Button
                onClick={handleSaveEdit}
                variant="contained"
                color="success"
                sx={{ width: 120 }}
              >
                SAVE
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  )
};
export default LelangKontrakListPage;
